import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";
import {
  TextField,
  Checkbox,
  Radio,
  FormControlLabel,
  FormGroup,
  FormControl,
  Button,
  FormHelperText,
} from "@material-ui/core";
import { APP_LIVE_URL, ADMIN_URL } from "../../config/config";
import {
  DateTimePicker,
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import { CopyToClipboard } from "react-copy-to-clipboard";
import html2canvas from "html2canvas";

import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Select from "react-select";
import countryList from "react-select-country-list";
import ReCAPTCHA from "react-google-recaptcha";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

const populatedynamicValues = (clientsData, value_name) => {
  if (clientsData && clientsData.length > 0) {
    const valueMap = {
      fullname: clientsData[0].name,
      company: clientsData[0].comp_name,
      email: clientsData[0].email,
      phone: clientsData[0].phone,
      address: clientsData[0].address,
      appartment: clientsData[0].address2,
      city: clientsData[0].city,
      state: clientsData[0].state,
      zip: clientsData[0].zip,
      country: clientsData[0].country,
    };

    if (value_name === "full_address") {
      return [
        clientsData[0].address,
        clientsData[0].address2,
        clientsData[0].city,
        clientsData[0].state,
        clientsData[0].zip,
        clientsData[0].country,
      ]
        .filter(Boolean)
        .join(", ");
    }

    return valueMap[value_name] || "";
  } else {
    return "";
  }
};

const resolveFccDynamicValue = (fccData, key) => {
  if (!fccData || !key || !key.startsWith("fcc.")) return "";
  try {
    // key format: fcc.<section>.<field>
    // e.g. fcc.robocall_data.business_name
    // fcc_raw_data is stored as: { robocall_data: {...}, 499_filer_data: {...} }
    // OR wrapped as: { frn_details: { data: { robocall_data: {...}, ... } } }
    const parts = key.split(".");
    if (parts.length < 3) return "";
    const section = parts[1]; // e.g. "robocall_data" or "499_filer_data"
    const field = parts.slice(2).join("."); // e.g. "business_name"

    // Support both stored formats: direct or wrapped in frn_details.data
    const data = fccData?.frn_details?.data || fccData;
    if (!data) return "";

    const sectionData = data[section];
    if (!sectionData) return "";

    return sectionData[field] != null ? String(sectionData[field]) : "";
  } catch (e) {
    return "";
  }
};

const SIPNAV_BOOLEAN_FIELDS = new Set([
  "enforce_cid_block",
  "international_calls",
  "block_wireless",
  "block_dnc",
  "remove_cid_name",
]);

const SIPNAV_COMMA_FIELDS = new Set([
  "disable_call_restrictions",
  "ani_blacklist",
  "dnis_blacklist",
]);

const resolveSipnavDynamicValue = (sipnavData, key) => {
  if (!sipnavData || !key || !key.startsWith("sipnav.")) return "";
  try {
    const field = key.slice("sipnav.".length);
    const val = sipnavData[field];
    if (val == null) return "";
    if (SIPNAV_COMMA_FIELDS.has(field)) {
      return String(val)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    if (SIPNAV_BOOLEAN_FIELDS.has(field)) {
      return String(val) === "1" || val === 1 ? "Yes" : "No";
    }
    return String(val);
  } catch (e) {
    return "";
  }
};

const loadFonts = () => {
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css2?family=Amita&family=Bad+Script&family=Damion&family=Dancing+Script&family=Felipa&family=Julee&family=Kaushan+Script&family=Lugrasimo&family=Pacifico&family=Sofia&family=Yellowtail&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

const cursiveFonts = [
  { name: "Your Signature", value: "'Amita', cursive" },
  { name: "Your Signature", value: "'Bad Script', cursive" },
  { name: "Your Signature", value: "'Damion', cursive" },
  { name: "Your Signature", value: "'Dancing Script', cursive" },
  { name: "Your Signature", value: "'Felipa', cursive" },
  { name: "Your Signature", value: "'Julee', cursive" },
  { name: "Your Signature", value: "'Kaushan Script', cursive" },
  { name: "Your Signature", value: "'Lugrasimo', cursive" },
  { name: "Your Signature", value: "'Pacifico', cursive" },
  { name: "Your Signature", value: "'Sofia', cursive" },
  { name: "Your Signature", value: "'Yellowtail', cursive" },
  // Add more cursive fonts here
];

const FormRendererClient = ({
  formData,
  formTitle,
  formDescription,
  onSubmit,
  onToast,
  groups,
  responseMessage,
  clientData,
  allow_submit,
  draftData,
  saveDraft,
  progressStep,
  viewFrom,
  service_data,
  service_id,
  isFormInReviewMode,
  allowSkip,
  onSkipStep,
  isOnboarding,
  stepsData,
  clientAccountNo,
  formAccountNo,
  formToken,
  stepTitle,
  isFilled = 0,
  isSkipped = 0,
  onNextStep = () => {},
  captcha_enabled = 0,
  link_form = 0,
  fccData = null,
  sipnavData = null,
}) => {
  // console.log("service_data: ", service_data);
  const [formState, setFormState] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [validationSummary, setValidationSummary] = useState(null); // { count, firstId } | null
  const [errorMessage, setErrorMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(progressStep);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [signatureType, setSignatureType] = useState("draw");
  const [signatureText, setSignatureText] = useState("");
  const [signatureClass, setSignatureClass] = useState("'Amita', cursive");
  const sigPadRefs = useRef([]);

  const [country, setCountry] = useState("");
  const [Address, setAddress] = useState("");
  const [submission, setSubmission] = useState("");
  const countryOptions = countryList().getData();
  const [selectedServices, setSelectedServices] = useState(() => {
    return service_id
      ? [Number(service_id)]
      : service_data?.map(([id]) => id) || [];
  });
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const [hoveredId, setHoveredId] = useState(null);
  const isSPLayout = viewFrom === "client-logged-in" || viewFrom === "client-not-logged-in";

  const showToastError = (message, title = "Error") => {
    const cleanedMessage = String(message || "There is some error while processing your request.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "error", title);
    }
  };

  const showToastSuccess = (message, title = "Success") => {
    const cleanedMessage = String(message || "Action completed successfully.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "success", title);
    }
  };

  const showToastWarning = (message, title = "Missing Fields") => {
    const cleanedMessage = String(message || "Please review the highlighted field.")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, "warning", title);
    }
  };

  // Determine if CAPTCHA should be shown
    // Phase 2: Single-page layout state
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [showFloatingNav, setShowFloatingNav] = useState(false);
    const [mobileNavVisible, setMobileNavVisible] = useState(false);
    const sectionRefs = useRef([]);
    const tabsContainerRef = useRef(null);
    const heroRef = useRef(null);
    const mobileNavTimerRef = useRef(null);
    const isScrollingRef = useRef(false);

    // Determine if CAPTCHA should be shown
    // CAPTCHA is shown when:
  // 1. captcha_enabled === 1
  // 2. NOT a link form (link_form !== 1)
  // 3. For multi-step forms: only on the last step
  // 4. For single-step forms: always if captcha_enabled
  const isLastStep = groups && groups.length > 0 ? currentStep === groups.length - 1 : true;
  const isMultiStepForm = groups && groups.length > 1;
  const formDataKey = JSON.stringify(formData || []);
  const shouldShowCaptcha = 
    captcha_enabled === 1 && 
    link_form !== 1 && 
    (isMultiStepForm ? isLastStep : true);

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };
  const hasUserEnteredData = (stateObj) => {
    if (!stateObj) return false;

    return Object.values(stateObj).some((value) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (Array.isArray(value)) return value.length > 0;
      return true;
    });
  };
  //console.log("draftData: ", draftData);
  useEffect(() => {
    const initialState = {};
    
    // Build a map from draftData if available
    const draftAnswers = {};
    if (draftData && draftData.length > 0) {
      draftData[0].questions.forEach((question) => {
        draftAnswers[question.id] = question.answer;
      });
    }
    
    // Initialize form state with proper priority: 
    // answer (from draftData) > defaultValue > dynamicValue > empty string
    formData.forEach((section) => {
      section.questions.forEach((question) => {
        // Priority 1: Check if draftData has an answer (including empty string explicitly set)
        if (draftAnswers.hasOwnProperty(question.id) && draftAnswers[question.id] !== "") {
          initialState[question.id] = draftAnswers[question.id];
        }
        // Priority 2: Check for defaultValue
        else if (question.defaultValue && question.defaultValue !== "") {
          initialState[question.id] = question.defaultValue;
        }
        // Priority 3: Check for dynamicValue
        else if (question.dynamicValue) {
          if (question.dynamicValue.startsWith("fcc.")) {
            initialState[question.id] = resolveFccDynamicValue(
              fccData,
              question.dynamicValue,
            );
          } else if (question.dynamicValue.startsWith("sipnav.")) {
            initialState[question.id] = resolveSipnavDynamicValue(
              sipnavData,
              question.dynamicValue,
            );
          } else {
            initialState[question.id] = populatedynamicValues(
              clientData,
              question.dynamicValue,
            );
          }
        }
        // Priority 4: Default to empty
        else {
          initialState[question.id] = "";
        }
      });
    });

    setFormState((prevState) => {
      if (!prevState || Object.keys(prevState).length === 0) {
        return initialState;
      }

      if (hasUserEnteredData(prevState)) {
        // Preserve already-entered values when parent re-renders.
        return {
          ...initialState,
          ...prevState,
        };
      }

      return initialState;
    });
  }, [draftData, formDataKey, clientData, fccData, sipnavData]);

  // Reset group index when form changes (e.g., when navigating between stepper steps)
  useEffect(() => {
    // console.log(
    //   "🔄 Form or progressStep changed, resetting currentStep to:",
    //   progressStep || 0
    // );
    setCurrentStep(progressStep || 0);
  }, [formDataKey, groups, progressStep]);

  const hasUngroupedQuestions = formData.some((form) =>
    form.questions.some((q) => !groups?.flat().includes(q.id))
  );

  // Track active step while scrolling (suppressed during programmatic scroll)
  useEffect(() => {
    if (!isSPLayout) return;
    const obs = [];
    sectionRefs.current.forEach((el, idx) => {
      if (!el) return;
      const o = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !isScrollingRef.current) setActiveTabIndex(idx);
        },
        { threshold: 0.3, rootMargin: "-60px 0px -40% 0px" }
      );
      o.observe(el);
      obs.push(o);
    });
    return () => obs.forEach((o) => o.disconnect());
  }, [viewFrom, groups]);

  // Show floating nav when the hero section leaves the viewport
  useEffect(() => {
    if (!isSPLayout || !groups || groups.length <= 1) return;
    const el = heroRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setShowFloatingNav(!entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [viewFrom, groups]);

  // Mobile: flash floating nav on scroll activity, auto-hide after 2s
  useEffect(() => {
    if (!isSPLayout) return;
    const show = () => {
      if (!showFloatingNav) return;
      setMobileNavVisible(true);
      if (mobileNavTimerRef.current) clearTimeout(mobileNavTimerRef.current);
      mobileNavTimerRef.current = setTimeout(() => setMobileNavVisible(false), 2000);
    };
    window.addEventListener("scroll", show, { passive: true });
    window.addEventListener("touchmove", show, { passive: true });
    return () => {
      window.removeEventListener("scroll", show);
      window.removeEventListener("touchmove", show);
      if (mobileNavTimerRef.current) clearTimeout(mobileNavTimerRef.current);
    };
  }, [viewFrom, showFloatingNav]);

  const handleCheckboxChangeNew = (id) => {
    setSelectedServices((prev) =>
      prev.includes(id)
        ? prev.filter((serviceId) => serviceId !== id)
        : [...prev, id],
    );
  };

  const ungroupedQuestions = formData
    .flatMap((form) => form.questions)
    .filter((question) => !groups.flat().includes(question.id));

  const handleChange = (questionId, value, inputFormat) => {
    if (inputFormat === "number_only") {
      value = value.replace(/[^0-9]/g, "");
    } else if (inputFormat === "alphabet_only") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (inputFormat === "alphanumeric") {
      value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    // console.log("questionId  value: " + questionId + "  " + value);
    setFormState({
      ...formState,
      [questionId]: value,
    });
    setFormErrors({
      ...formErrors,
      [questionId]: "",
    });
  };

  const handleChangeSignature = (questionId, value) => {
    setSignatureText(value);
  };

  const handleChangeFixed = (questionId, value) => {
    setFormState({
      ...formState,
    });
  };

  // const handleCheckboxChange = (questionId, option, isChecked) => {
  //   const currentOptions = formState[questionId] || [];
  //   if (isChecked) {
  //     setFormState({
  //       ...formState,
  //       [questionId]: [...currentOptions, option],
  //     });
  //   } else {
  //     setFormState({
  //       ...formState,
  //       [questionId]: currentOptions.filter((opt) => opt !== option),
  //     });
  //   }
  //   setFormErrors({
  //     ...formErrors,
  //     [questionId]: "",
  //   });
  // };

  const handleCheckboxChange = (questionId, option, isChecked) => {
    setFormState((prevState) => {
      const currentOptions = prevState[questionId] || [];

      let updatedOptions;
      if (isChecked) {
        // Avoid duplicates (case-insensitive) then add with the option's own casing
        const alreadyIn = currentOptions.some(
          (o) => o.toLowerCase() === option.toLowerCase()
        );
        updatedOptions = alreadyIn ? currentOptions : [...currentOptions, option];
      } else {
        // Remove case-insensitively so pre-filled lowercase values can be unchecked
        updatedOptions = currentOptions.filter(
          (o) => o.toLowerCase() !== option.toLowerCase()
        );
      }
      return {
        ...prevState,
        [questionId]: updatedOptions,
      };
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [questionId]: "",
    }));
  };

  const handleFileChange = (questionId, event) => {
    if (event.target && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        axios
          .post(
            `${process.env.REACT_APP_API_URL}forms/form_image_response`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((response) => {
            // console.log("handleFileChange: ", response);
            const imageUrl = response.data.default;
            setFormState((prevFormState) => ({
              ...prevFormState,
              [questionId]: imageUrl,
            }));
            setFormErrors((prevFormErrors) => ({
              ...prevFormErrors,
              [questionId]: "",
            }));
          })
          .catch((error) => {
            console.error("There was an error uploading the image!", error);
          });
      }
    } else {
      console.error("No file selected or event target is undefined.");
    }
  };

  const removeUploadedFile = (questionId) => {
    if (questionId && questionId !== "") {
      const formData = new FormData();
      setFormState((prevFormState) => ({
        ...prevFormState,
        [questionId]: "",
      }));
    }
  };

  const isPhoneValid = (value) => {
    if (!value) return false;
    try {
      const parsed = parsePhoneNumberFromString("+" + value.replace(/^\+/, ""));
      return parsed ? parsed.isValid() : false;
    } catch {
      return false;
    }
  };

  // A phone control seeded with only a dial code has no national number;
  // treat that as empty so optional phones pass and required ones report "required".
  const isPhoneEmpty = (value) => {
    if (!value || !String(value).trim()) return true;
    try {
      const parsed = parsePhoneNumberFromString("+" + String(value).replace(/^\+/, "").trim());
      const nsn = parsed?.nationalNumber;
      return !nsn || nsn === "0";
    } catch {
      return true;
    }
  };

  const handleChangeCountry = (questionId, selectedOption) => {
    const selectedLabel = selectedOption ? selectedOption.label : "";

    setFormState((prevState) => ({
      ...prevState,
      [questionId]: selectedLabel,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));

    setCountry(selectedOption);

    //console.log("Selected Country Label:", selectedLabel);
  };

  const handleAddressSelect = async (questionId, place) => {
    // console.log("place", place);

    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();
      // console.log("handleAddressSelect data: ", data);
      if (data.status === "OK") {
        const formattedAddress = data.results[0].formatted_address;
        const addressComponents = data.results[0].address_components;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        let zip = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        let full_address =
          streetAddress +
          address2 +
          ", " +
          city +
          ", " +
          state +
          ", " +
          zipCode +
          ", " +
          country;

        setFormState((prevState) => ({
          ...prevState,
          [questionId]: full_address || "",
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [questionId]: "",
        }));

        // Store the formatted address
        setAddress(full_address || "");
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  const handleChangePhone = (questionId, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [questionId]: value,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));

    //console.log("Phone Number:", value);
  };

  const handleSubmit = async () => {
    // Prevent form submission if in review mode
    if (isFormInReviewMode) {
      // console.log("⚠️ Form is in review mode - submission disabled");
      setErrorMessage(
        "This form has already been submitted. You can only review it now.",
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
    const requiredQuestions = formData.flatMap((form) =>
      form.questions.filter((question) => question.required),
    );

    const currentGroup = groups[currentStep];

    const validationQuestions = formData.flatMap((form) =>
      form.questions.filter(
        (question) =>
          question.validationValue &&
          currentGroup.questions.includes(question.id),
      ),
    );

    let hasErrors = false;
    let emptyFieldMessages = [];
    let validationMessages = [];
    let filerId = null; // Initialize variable to store filer_id
    let fullAddress = null; // Initialize variable to store full_address

    requiredQuestions.forEach((question) => {
      if (!formState[question.id]) {
        hasErrors = true;
      }
    });

    const { isValid, missingFields } = validateCurrentGroup();

    if (!isValid) {
      const fieldsList = missingFields.join(", ");
      emptyFieldMessages.push(
        `Please fill out all required fields: ${fieldsList}`,
      );
      hasErrors = true;
    }

    validationQuestions.forEach((question) => {
      const value = formState[question.id]?.trim();
      // console.log("value", value);

      if (value && value !== "") {
        // Perform various validations based on question validation value
        if (question.validationValue === "validation_email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid email address.");
          }
        }

        if (question.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid phone number.");
          }
        }

        if (question.validationValue === "validation_zip") {
          const zipRegex = /^[A-Za-z0-9\s\-]{4,10}$/;
          if (!zipRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid postal code.");
          }
        }

        if (question.validationValue === "validation_address") {
          const addressRegex = /^[0-9a-zA-Z\s,.'\-#()]+$/;
          const wordCount = value.trim().split(/\s+/).length;

          if (!addressRegex.test(value) || wordCount < 5) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a complete address containing at least 5 words.",
            );
          }
        }

        if (question.validationValue === "validation_city") {
          const cityRegex = /^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/;
          if (!cityRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "City must contain only letters, spaces, hyphens, or valid special characters.",
            );
          }
        }

        if (question.validationValue === "validation_state") {
          const stateRegex = /^[a-zA-Z\s]+$/;
          if (!stateRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "State should contain only letters and spaces.",
            );
          }
        }

        if (question.validationValue === "validation_ip") {
          // IPv4 regex - no leading zeros allowed
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

          // IPv6 regex - supports shorthand (::) and expanded addresses
          const ipv6Regex =
            /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;

          if (!ipv4Regex.test(value) && !ipv6Regex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a valid IP address (IPv4 or IPv6).",
            );
          }
        }

        if (question.validationValue === "validation_filerId") {
          const filerIdRegex = /^[A-Z0-9]{0,10}$/;
          if (!filerIdRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Filer ID should be exactly 6 alphanumeric characters.",
            );
          }
          if (value) {
            filerId = value;
          }
        }

        if (question.validationValue === "validation_fulladdress") {
          if (value) {
            fullAddress = value;
          }
        }
      }
    });

    if (hasErrors) {
      let finalErrorMessage = "";

      if (emptyFieldMessages.length > 0) {
        finalErrorMessage += emptyFieldMessages.join("<br />") + "<br />";
      }

      if (validationMessages.length > 0) {
        finalErrorMessage += validationMessages.join("<br />");
      }

      setErrorMessage(finalErrorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    // CAPTCHA validation
    if (shouldShowCaptcha && (!captchaToken || captchaToken === "")) {
      setErrorMessage("Please complete the CAPTCHA.");
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    setLoading(true);
    //console.log("formData Before: ", formData);
    try {
      // Await the verification process before proceeding
      await verifyInfoSubmit(filerId, fullAddress);

      // Prepare form data to send
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: form.questions.map((question) => ({
          ...question,
          answer:
            question.answerType === "fixed"
              ? question.answer
              : formState[question.id],
        })),
        errorMessage: form.errorMessage,
      }));

      // Submit form data only after the verification is complete
      // Pass the current group index and total groups count
      await onSubmit(
        formDataToSend,
        selectedServices,
        currentStep,
        groups.length,
      );
      setTimeout(() => {
        setLoading(false);
      }, 5000);
    } catch (error) {
      console.error("Error submitting the form:", error);
      setLoading(false);
    }
  };

  /*const handleNextStep = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("validateCurrentGroup(): ", validateCurrentGroup());
    if (validateCurrentGroup()) {
      setCurrentStep(currentStep + 1);
    } else {
      setErrorMessage(
        "Please fill out all required fields in the current group."
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 3500);
    }
  };*/

  /*const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return false;

    const hasEmptyRequiredFields = currentGroup.questions.some((questionId) => {
      const question = formData[0].questions.find((q) => q.id === questionId);
      
      if (question) {
        //return question.required && !formState[question.id];
        return question;
      }
    });

    return !hasEmptyRequiredFields;
  };*/

  const handleNextStep = async () => {
    const { isValid, missingFields } = validateCurrentGroup();
    window.scrollTo({ top: 0, behavior: "smooth" });
    let hasErrors = false;
    let emptyFieldMessages = [];
    let validationMessages = [];
    let filerId = null; // Initialize variable to store filer_id
    let fullAddress = null; // Initialize variable to store full_address

    if (!isValid) {
      const fieldsList = missingFields.join(", ");
      emptyFieldMessages.push(
        `Please fill out all required fields: ${fieldsList}`,
      );
      hasErrors = true;
    }

    const currentGroup = groups[currentStep];

    const validationQuestions = formData.flatMap((form) =>
      form.questions.filter(
        (question) =>
          question.validationValue &&
          currentGroup.questions.includes(question.id),
      ),
    );

    validationQuestions.forEach((question) => {
      const value = formState[question.id]?.trim();

      if (value && value !== "") {
        if (question.validationValue === "validation_email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid email address.");
          }
        }

        if (question.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid phone number.");
          }
        }

        if (question.validationValue === "validation_zip") {
          const zipRegex = /^[A-Za-z0-9\s\-]{4,10}$/;
          if (!zipRegex.test(value)) {
            hasErrors = true;
            validationMessages.push("Please enter a valid postal code.");
          }
        }

        if (question.validationValue === "validation_address") {
          const addressRegex = /^[0-9a-zA-Z\s,.'\-#()]+$/;
          if (!addressRegex.test(value) || value.length < 5) {
            hasErrors = true;
            validationMessages.push(
              "Address should be at least 5 characters long and contain valid characters.",
            );
          }
        }

        if (question.validationValue === "validation_city") {
          const cityRegex = /^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/;
          if (!cityRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "City must contain only letters, spaces, hyphens, or valid special characters.",
            );
          }
        }

        if (question.validationValue === "validation_state") {
          const stateRegex = /^[a-zA-Z\s]+$/;
          if (!stateRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "State should contain only letters and spaces.",
            );
          }
        }

        if (question.validationValue === "validation_ip") {
          // IPv4 regex - no leading zeros allowed
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

          // IPv6 regex - supports shorthand (::) and expanded addresses
          const ipv6Regex =
            /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;

          if (!ipv4Regex.test(value) && !ipv6Regex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Please enter a valid IP address (IPv4 or IPv6).",
            );
          }
        }

        if (question.validationValue === "validation_filerId") {
          const filerIdRegex = /^[A-Z0-9]{0,10}$/;
          if (!filerIdRegex.test(value)) {
            hasErrors = true;
            validationMessages.push(
              "Filer ID should be exactly 6 alphanumeric characters.",
            );
          }
        }
        if (question.validationValue === "validation_filerId") {
          if (value) {
            filerId = value;
          }
        }

        if (question.validationValue === "validation_fulladdress") {
          if (value) {
            fullAddress = value;
          }
        }
      }
    });

    if (hasErrors) {
      let finalErrorMessage = "";

      if (emptyFieldMessages.length > 0) {
        finalErrorMessage += emptyFieldMessages.join("<br />") + "<br />";
      }

      if (validationMessages.length > 0) {
        finalErrorMessage += validationMessages.join("<br />");
      }

      setErrorMessage(finalErrorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return;
    }

    if (filerId) {
      // console.log("Filer ID:", filerId);
    }

    if (fullAddress) {
      // console.log("Full Address:", fullAddress);
    }

    //verifyInfo(filerId, fullAddress);

    let isFilerVerified = true;
    setLoading(true);
    if (!filerId || !fullAddress) {
      isFilerVerified = await verifyInfo(filerId, fullAddress);
    }
    if (isFilerVerified) {
      setLoading(false);
      // console.log(
      //   "✅ handleNextStep: Validation passed, advancing to next group"
      // );

      // Save current group's data before advancing (especially for multi-group onboarding forms)
      const currentGroupNumber = currentStep + 1;
      if (saveDraft && typeof saveDraft === "function") {
        const formDataToSend = formData.map((form) => ({
          title: form.title,
          id: form.id,
          questions: form.questions.map((question) => ({
            ...question,
            answer:
              question.answerType === "fixed"
                ? question.answer
                : formState[question.id],
          })),
          errorMessage: form.errorMessage,
        }));

        // console.log(
        //   "💾 Saving current group",
        //   currentGroupNumber,
        //   "before moving to next group"
        // );
        saveDraft(formDataToSend, currentGroupNumber);
      }

      // Advance to next group
      setCurrentStep((prevStep) => prevStep + 1);
    } else {
      setLoading(false);
      console.error("❌ handleNextStep: Filer verification failed");
    }
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  // const validateCurrentGroup = () => {
  //   const currentGroup = groups[currentStep];
  //   if (!currentGroup) return { isValid: false, missingFields: [] };

  //   const missingFields = currentGroup.questions
  //     .map((questionId) => {
  //       const question = formData[0].questions.find((q) => q.id === questionId);

  //       if (question && question.required && !formState[question.id]) {
  //         return question.questionText; // Return the question text (field name) if it's required and empty
  //       }
  //       return null;
  //     })
  //     .filter(Boolean); // Filter out any null values

  //   return {
  //     isValid: missingFields.length === 0,
  //     missingFields: missingFields,
  //   };
  // };

  const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return { isValid: false, missingFields: [] };

    const missingFields = currentGroup.questions
      .map((questionId) => {
        const question = formData[0].questions.find((q) => q.id === questionId);
        const value = formState[question?.id];

        // Properly handle different value types
        const isEmpty =
          question?.validationValue === "validation_phone"
            ? isPhoneEmpty(value)
            : value === undefined ||
              value === null ||
              (typeof value === "string" && value.trim() === "") ||
              (Array.isArray(value) && value.length === 0);

        if (question && question.required && isEmpty) {
          return question.questionText; // Return field name if required and empty
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    //console.log("[missingFields]", missingFields);

    return {
      isValid: missingFields.length === 0,
      missingFields,
    };
  };

  const verifyInfo = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    const verificationRequest = axios.post(
      `${process.env.REACT_APP_API_URL}forms/verify_info`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      const response = await Promise.race([verificationRequest, timeout]);
      // console.log("Verification response: ", response);
      //setCurrentStep((prevStep) => prevStep + 1);

      // Return the response data for further use if needed
      return true;
    } catch (error) {
      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;
        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      setErrorMessage(errorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 4500);
      return false;
    } finally {
      // Reset the loading state after the request completes
      setLoading(false);
    }
  };

  /*const verifyInfo = (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}forms/verify_info`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Verification response: ", response.data);
        setCurrentStep(currentStep + 1);
      })
      .catch((error) => {
        if (error.response) {
          const { status, data } = error.response;
          let errorMessage;

          window.scrollTo({ top: 0, behavior: "smooth" });

          const formattedErrorMessage = data.errors
            ? String(data.errors).replace(/,/g, "<br />")
            : null;

          switch (status) {
            case 411:
              errorMessage = `Invalid Filer ID<br />${
                formattedErrorMessage ||
                "Both Filer ID and address validation failed."
              }`;
              break;
            case 410:
              errorMessage = "Invalid FCC Filer ID.";
              break;
            case 409:
              errorMessage =
                formattedErrorMessage || "Address validation failed";
              break;
            default:
              errorMessage = "An unexpected error occurred.";
          }

          setErrorMessage(errorMessage);
          setTimeout(() => {
            setErrorMessage("");
          }, 4500);

          return;
        } else {
          setErrorMessage("There was an error verifying the information!");
          setTimeout(() => {
            setErrorMessage("");
          }, 4500);
        }
      });
  };*/

  const verifyInfoSubmit = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    // Create a timeout promise
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      // Use Promise.race to handle both the request and the timeout
      const response = await Promise.race([
        axios.post(
          `${process.env.REACT_APP_API_URL}forms/verify_info`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        ),
        timeout,
      ]);

      // console.log("Verification response: ", response);
      setSubmission(true);
      return response;
    } catch (error) {
      setSubmission(false);

      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;

        window.scrollTo({ top: 0, behavior: "smooth" });

        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      showToastError(errorMessage);
      setErrorMessage("");

      throw error;
    }
  };

  /*const verifyInfoSubmit = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}forms/verify_info`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Verification response: ", response);
      setSubmission(true); // Set submission success state
      return response; // Return response so that it can be used elsewhere if needed
    } catch (error) {
      setSubmission(false); // Set submission failure state

      if (error.response) {
        const { status, data } = error.response;
        let errorMessage;

        window.scrollTo({ top: 0, behavior: "smooth" });

        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }

        setErrorMessage(errorMessage);
        setTimeout(() => {
          setErrorMessage("");
        }, 4500);
      } else {
        setErrorMessage("There was an error verifying the information!");
        setTimeout(() => {
          setErrorMessage("");
        }, 4500);
      }

      throw error; // Ensure errors propagate so the caller knows about the failure
    }
  };*/

  const clearSignature = (index) => {
    if (sigPadRefs.current[index]) {
      sigPadRefs.current[index].clear();
      $("#divSig" + index).hide();
      $(".clsimgSig").attr("src", "");
      $(".clsimgSig").hide();
    }
  };

  const previewSignature = (index) => {
    if (sigPadRefs.current[index]) {
      const dataUrl = sigPadRefs.current[index].toDataURL();
      var data = sigPadRefs.current[index]
        .getTrimmedCanvas()
        .toDataURL("image/svg+xml");
      $("#divSig" + index).show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
      // console.log("Signature Preview:", dataUrl);
      // You can do something with the dataUrl, like displaying it or saving it
    }
  };

  const saveSignature = async (index) => {
    const signaturePad = sigPadRefs.current[index];

    if (signaturePad && !signaturePad.isEmpty()) {
      try {
        // Generate the trimmed signature as a base64 string
        const trimmedDataUrl = signaturePad
          .getTrimmedCanvas()
          .toDataURL("image/svg+xml");

        // Prepare the JSON payload
        const payload = {
          signature: trimmedDataUrl,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        // Check if response status is 200 and contains the expected data
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToastSuccess("Signature saved successfully.", "Saved");
          setErrorMessage("");

          // console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        // Handle errors and update state
        console.error(
          `Error uploading the signature for index ${index + 1}:`,
          error.message,
        );

        // Optionally, update form errors state to show the error message
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToastError("Failed to save signature. Please try again.");
        setErrorMessage("");
      }
    } else {
      showToastError("Signature is empty.");
      setErrorMessage("");
      // console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const saveChooseImage = async (index) => {
    const element = document.getElementById("styled-text-container" + index);
    if (element) {
      if (signatureText.trim() === "") {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: "Please enter the signature text before saving.",
        }));
        showToastError("Signature text is empty.");
        setErrorMessage("");
        return;
      }
      try {
        const canvas = await html2canvas(element, {
          scale: 2,
          backgroundColor: null,
        });
        const imgData = canvas.toDataURL("image/png");
        const payload = {
          signature: imgData,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_choose_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToastSuccess("Signature saved successfully.", "Saved");
          setErrorMessage("");
          // console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToastError("Failed to save signature. Please try again.");
        setErrorMessage("");
      }
    } else {
      showToastError("Signature is empty.");
      setErrorMessage("");
      // console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = ADMIN_URL + "files_data/form_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "File not found.",
      });
      /*setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);*/
    }
  };

  //Show Groups by sequence Number
  if (groups) {
    groups = groups.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
  }

  const currentGroup = groups && groups.length > 0 ? groups[currentStep] : null;
  //console.log("formData: ", formData);

    // ── Phase 2: Single-page layout helpers ──
    const STATIC_TYPES_SP = ["text_only", "rich_text", "notice_text", "warning_text"];

    const getQuestionColClassSP = (question, group) => {
      if (!question) return "col-sm-12";
      if (question.answerType === "label" || STATIC_TYPES_SP.includes(question.answerType)) return "col-sm-12";
      if (group && group.column_layout === "double_column") return "col-sm-6";
      return "col-sm-12";
    };

    const smoothScrollTo = (targetY, duration = 650) => {
      const startY = window.scrollY;
      const diff = targetY - startY;
      if (Math.abs(diff) < 2) return;
      const ease = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      let startTime = null;
      const tick = (now) => {
        if (!startTime) startTime = now;
        const progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, startY + diff * ease(progress));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const scrollToSection = (index) => {
      setActiveTabIndex(index);
      const el = sectionRefs.current[index];
      if (!el) return;
      isScrollingRef.current = true;
      setTimeout(() => { isScrollingRef.current = false; }, 750);
      const rect = el.getBoundingClientRect();
      smoothScrollTo(window.scrollY + rect.top - 80, 650);
    };

    const SELECT_TYPES_SP = ["dropdown", "select", "radio", "checkbox", "multiselect", "multi_select"];

    // Resolve the step (group) name, field label, and answer type for a given field id.
    const getFieldMeta = (fieldId) => {
      if (!fieldId) return null;
      const group = (groups || []).find((g) => g.questions.includes(fieldId));
      const q = formData[0]?.questions.find((x) => x.id === fieldId);
      if (!q) return null;
      return {
        stepName: group?.group_title || "",
        label: q.questionText || "",
        answerType: q.answerType,
      };
    };

    // Build a "Please enter/select {Label} in {Step}" message for a required field.
    const buildRequiredMessage = (meta) => {
      if (!meta) return "Please review the highlighted field.";
      const verb = SELECT_TYPES_SP.includes(meta.answerType) ? "select" : "enter";
      const inStep = meta.stepName ? ` in ${meta.stepName}` : "";
      return `Please ${verb} ${meta.label}${inStep}`;
    };

    // Scroll the first invalid field into view and move focus to its input.
    const focusFirstInvalid = (fieldId) => {
      setTimeout(() => {
        const el = fieldId ? document.getElementById(`sp-field-${fieldId}`) : null;
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          const focusable = el.querySelector("input, select, textarea, [tabindex]");
          if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 350);
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 50);
    };

    const validateAllGroupsSP = () => {
      if (!groups || !groups.length) return { isValid: true, missingFields: [], missingFieldIds: [], firstInvalidId: null };
      const missingFields = [];
      const missingFieldIds = [];
      let firstInvalidId = null;
      groups.forEach((group) => {
        group.questions.forEach((questionId) => {
          const q = formData[0]?.questions.find((x) => x.id === questionId);
          if (!q || !q.required || STATIC_TYPES_SP.includes(q.answerType)) return;
          const val = formState[q.id];
          const empty =
            q.validationValue === "validation_phone"
              ? isPhoneEmpty(val)
              : val === undefined ||
                val === null ||
                (typeof val === "string" && val.trim() === "") ||
                (Array.isArray(val) && val.length === 0);
          if (empty) {
            missingFields.push(q.questionText);
              missingFieldIds.push(q.id);
            if (!firstInvalidId) firstInvalidId = q.id;
          }
        });
      });
        return { isValid: missingFields.length === 0, missingFields, missingFieldIds, firstInvalidId };
    };

    const handleSubmitSinglePage = async () => {
      if (isFormInReviewMode) {
        showToastError("This form has already been submitted. You can only review it now.");
        setErrorMessage("");
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      const { isValid, missingFields, missingFieldIds, firstInvalidId } = validateAllGroupsSP();
      let hasErrors = !isValid;
      const msgs = [];
      const fieldErrors = {};
      let firstErrorFieldId = firstInvalidId;
      let filerId = null;
      let fullAddress = null;
      if (!isValid) {
        msgs.push(`Please fill out all required fields: ${missingFields.join(", ")}`);
        missingFieldIds.forEach((id) => {
          fieldErrors[id] = "This field is required.";
        });
      }
      const allValQs = formData.flatMap((form) => form.questions.filter((q) => q.validationValue));
      allValQs.forEach((q) => {
        const raw = formState[q.id];
        const value = typeof raw === "string" ? raw.trim() : "";
        if (!value) return;
        if (q.validationValue === "validation_email") {
          if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
            hasErrors = true;
            msgs.push("Please enter a valid email address.");
            fieldErrors[q.id] = fieldErrors[q.id] || "Please enter a valid email address.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            hasErrors = true;
            msgs.push("Please enter a valid phone number.");
            fieldErrors[q.id] = fieldErrors[q.id] || "Please enter a valid phone number.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_zip") {
          if (!/^[A-Za-z0-9\s\-]{4,10}$/.test(value)) {
            hasErrors = true;
            msgs.push("Please enter a valid postal code.");
            fieldErrors[q.id] = fieldErrors[q.id] || "Please enter a valid postal code.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_address") {
          if (!/^[0-9a-zA-Z\s,.'\-#()]+$/.test(value) || value.split(/\s+/).length < 5) {
            hasErrors = true;
            msgs.push("Please enter a complete address (at least 5 words).");
            fieldErrors[q.id] = fieldErrors[q.id] || "Please enter a complete address (at least 5 words).";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_city") {
          if (!/^[a-zA-Z\s.'\\-áéíóúÁÉÍÓÚñÑüÜ]+$/.test(value)) {
            hasErrors = true;
            msgs.push("City must contain only letters and valid special characters.");
            fieldErrors[q.id] = fieldErrors[q.id] || "City must contain only letters and valid special characters.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_state") {
          if (!/^[a-zA-Z\s]+$/.test(value)) {
            hasErrors = true;
            msgs.push("State should contain only letters and spaces.");
            fieldErrors[q.id] = fieldErrors[q.id] || "State should contain only letters and spaces.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_ip") {
          const ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          const ipv6 = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;
          if (!ipv4.test(value) && !ipv6.test(value)) {
            hasErrors = true;
            msgs.push("Please enter a valid IP address (IPv4 or IPv6).");
            fieldErrors[q.id] = fieldErrors[q.id] || "Please enter a valid IP address (IPv4 or IPv6).";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
        }
        if (q.validationValue === "validation_filerId") {
          if (!/^[A-Z0-9]{0,10}$/.test(value)) {
            hasErrors = true;
            msgs.push("Filer ID should be exactly 6 alphanumeric characters.");
            fieldErrors[q.id] = fieldErrors[q.id] || "Filer ID should be exactly 6 alphanumeric characters.";
            if (!firstErrorFieldId) firstErrorFieldId = q.id;
          }
          if (value) filerId = value;
        }
        if (q.validationValue === "validation_fulladdress" && value) fullAddress = value;
      });
      if (hasErrors) {
        // Highlight all invalid fields, but warn about (and focus) only the first one.
        setFormErrors(fieldErrors);
        setValidationSummary({
          count: Object.keys(fieldErrors).length,
          firstId: firstErrorFieldId,
        });
        const meta = getFieldMeta(firstErrorFieldId);
        const firstMsg = fieldErrors[firstErrorFieldId];
        let warningMessage;
        if (!firstMsg || firstMsg === "This field is required.") {
          warningMessage = buildRequiredMessage(meta);
        } else {
          // Format error (email/phone/etc.) — message is already user-friendly.
          warningMessage = meta?.stepName ? `${firstMsg} (in ${meta.stepName})` : firstMsg;
        }
        showToastWarning(warningMessage);
        setErrorMessage("");
        focusFirstInvalid(firstErrorFieldId);
        return;
      }
      setFormErrors({});
      setValidationSummary(null);
      if (captcha_enabled === 1 && link_form !== 1 && (!captchaToken || captchaToken === "")) {
        showToastError("Please complete the CAPTCHA.");
        setErrorMessage("");
        return;
      }
      setLoading(true);
      try {
        await verifyInfoSubmit(filerId, fullAddress);
        const formDataToSend = formData.map((form) => ({
          title: form.title,
          id: form.id,
          questions: form.questions.map((q) => ({
            ...q,
            answer: q.answerType === "fixed" ? q.answer : formState[q.id],
          })),
          errorMessage: form.errorMessage,
        }));
        await onSubmit(formDataToSend, selectedServices, 0, groups.length);
        setTimeout(() => setLoading(false), 5000);
      } catch (err) {
        console.error("Error submitting the form:", err);
        setLoading(false);
      }
    };
    // ── End Phase 2 helpers ──

    return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className="form-renderer-container" style={isSPLayout ? { background: "#eef1f7", minHeight: "100vh" } : {}}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {allowSkip === 1 &&
            isOnboarding &&
            isFilled !== 1 &&
            isSkipped !== 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={onSkipStep}
                style={{
                  marginTop: "10px",
                  justifyContent: "flex-end",
                }}
                title="Skip this step"
                className="skip-button-mobile"
              >
                <em className="icon ni ni-forward"></em> Skip This Step
              </Button>
            )}
          {(isFilled === 1 || isSkipped === 1) && (
            <Button
              variant="contained"
              color="primary"
              onClick={onNextStep}
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                textAlign: "right",
              }}
              className="next-button-mobile"
            >
              <em className="icon ni ni-forward"></em> Next Step
            </Button>
          )}
        </div>
        {isSPLayout ? (
          <>
              {/* ── HERO + TABS ── */}
              <div
                ref={heroRef}
                style={{
                  background: "#F5F6FA",
                  borderRadius: "16px",
                  marginBottom: "1.5rem",
                  overflow: "hidden",
                  border: "1px solid #dce2ec",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                }}
              >
                {/* Hero text */}
                <div style={{ padding: "36px 48px 28px", textAlign: "center" }}>
                  <h2
                    style={{
                      margin: "0 0 10px",
                      fontSize: "1.85rem",
                      fontWeight: 700,
                      color: "#1c2b46",
                      lineHeight: 1.25,
                      letterSpacing: "-0.02em",
                    }}
                  >
                    {formTitle || "Untitled Form"}
                  </h2>
                  {formDescription && (
                    <p
                      style={{
                        margin: "0 auto",
                        fontSize: "15px",
                        color: "#526484",
                        lineHeight: 1.7,
                        maxWidth: "600px",
                      }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: formDescription }} />
                    </p>
                  )}
                </div>

                {/* Nav tabs */}
                {groups && groups.length > 1 && (
                  <div
                    ref={tabsContainerRef}
                    className="obs-hero-tabs"
                    style={{
                      borderTop: "1px solid #dce2ec",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        overflowX: "auto",
                        padding: "0 24px",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      {groups.map((group, index) => {
                        const isActive = activeTabIndex === index;
                        return (
                          <button
                            key={group.id}
                            onClick={() => scrollToSection(index)}
                            type="button"
                            className="obs-tab-btn"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "9px",
                              padding: "14px 16px",
                              border: "none",
                              borderBottom: isActive
                                ? "3px solid #1ee0ac"
                                : "3px solid transparent",
                              background: "transparent",
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              transition: "border-color 0.2s ease",
                              outline: "none",
                              flexShrink: 0,
                            }}
                          >
                            <span
                              className="obs-tab-circle"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                                minWidth: "24px",
                                borderRadius: "50%",
                                background: isActive ? "#1ee0ac" : "#e4e9f2",
                                color: isActive ? "#0d1b38" : "#6b7c95",
                                fontSize: "11px",
                                fontWeight: 700,
                              }}
                            >
                              {index + 1}
                            </span>
                            <span
                              className="obs-tab-label"
                              style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                letterSpacing: "0.01em",
                                color: isActive ? "#0d1b38" : "#6b7c95",
                              }}
                            >
                              {group.group_title}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* ── CSS: scrollable tabs + mobile auto-hide floating nav ── */}
              <style>{`
                .obs-hero-tabs > div::-webkit-scrollbar { display: none; }

                /* ── Rich text horizontal scroll ── */
                .obs-rich-text-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
                .obs-rich-text-scroll table { min-width: max-content; border-collapse: collapse; }
                .obs-rich-text-scroll::-webkit-scrollbar { height: 4px; }
                .obs-rich-text-scroll::-webkit-scrollbar-thumb { background: #c8d3df; border-radius: 4px; }

                /* ── Form label sizing ── */
                .form-renderer-container .form-label {
                  font-size: 12.5px !important;
                  font-weight: 600 !important;
                  color: #526484 !important;
                  margin-bottom: 5px !important;
                  letter-spacing: 0.01em;
                }
                .form-renderer-container .form-label.obs-section-label {
                  font-size: 13.5px !important;
                  font-weight: 700 !important;
                  color: #344357 !important;
                  margin-bottom: 4px !important;
                }
                @media (max-width: 768px) {
                  .obs-hero-tabs { display: none !important; }
                  .obs-floating-nav {
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 0.35s ease !important;
                    right: 8px !important;
                    padding: 5px 4px !important;
                    gap: 3px !important;
                    border-radius: 20px !important;
                  }
                  .obs-floating-nav.obs-mobile-visible {
                    opacity: 1;
                    pointer-events: auto;
                  }
                  .obs-pill-btn {
                    width: 18px !important;
                    height: 18px !important;
                    font-size: 8px !important;
                  }
                }
                @media (min-width: 769px) and (max-width: 1024px) {
                  .obs-hero-tabs .obs-tab-btn {
                    padding: 12px 10px !important;
                  }
                  .obs-hero-tabs .obs-tab-label {
                    font-size: 11px !important;
                  }
                  .obs-hero-tabs .obs-tab-circle {
                    width: 22px !important;
                    height: 22px !important;
                    min-width: 22px !important;
                    font-size: 10px !important;
                  }
                  .obs-hero-tabs > div {
                    padding: 0 12px !important;
                  }
                }
              `}</style>

              {/* ── Floating vertical step pill — one button per step ── */}
              {groups && groups.length > 1 && (
                <div
                  className={`obs-floating-nav${mobileNavVisible ? " obs-mobile-visible" : ""}`}
                  style={{
                    display: showFloatingNav ? "flex" : "none",
                    position: "fixed",
                    right: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1000,
                    background: "#fff",
                    borderRadius: "30px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                    padding: "7px 5px",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "4px",
                    transition: "opacity 0.35s ease",
                  }}
                >
                  {groups.map((group, index) => {
                    const isActive = activeTabIndex === index;
                    return (
                      <button
                        key={group.id}
                        onClick={() => scrollToSection(index)}
                        title={group.group_title}
                        className="obs-pill-btn"
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          background: isActive ? "#0d1b38" : "#e4e9f2",
                          border: isActive ? "none" : "1px solid #c8d3df",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: isActive ? "#fff" : "#6b7c95",
                          fontSize: "9px",
                          fontWeight: 700,
                          transition: "all 0.25s ease",
                          padding: 0,
                          flexShrink: 0,
                        }}
                      >
                        {index + 1}
                      </button>
                    );
                  })}
                </div>
              )}

              <div>
                <div>
                  <div className="mb-2"></div>
                  {service_data && service_data.length ? (
                    <div className="mb-4" style={{ background: "#fff", borderRadius: "14px", boxShadow: "0 1px 12px rgba(0,0,0,0.08)", overflow: "hidden" }}>
                      <div className="card-inner">
                        <div className="sp-plan-head"><h4 className="title">Form Services</h4></div>
                        <p>This form is linked to the following services. Submitting it will also generate an order for the selected products. If you do not wish to create an order or remove any product, please uncheck the services.</p>
                        <ul className="nk-kycfm-control-list g-3">
                          {service_data?.map(([id, name]) => (
                            <li className="nk-kycfm-control-item" key={`ser-sp-${id}`}>
                              <input id={`sp-service-${id}`} checked={selectedServices.includes(id)} onChange={() => handleCheckboxChangeNew(id)} className="nk-kycfm-control" type="checkbox" name={name} data-title={name} value="Yes" />
                              <label className="nk-kycfm-label" htmlFor={`sp-service-${id}`}>
                                <span className="nk-kycfm-label-icon"><div className="label-icon"><em className="icon ni ni-card-view fs26px" style={{ marginRight: "15px" }}></em></div></span>
                                <span className="nk-kycfm-label-text">{name}</span>
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : null}
                  {responseMessage && <div dangerouslySetInnerHTML={{ __html: responseMessage }} />}
                  {errorMessage && (
                    <div className="alert alert-danger alert-icon mb-3">
                      <em className="icon ni ni-cross-circle"></em>{" "}
                      <div dangerouslySetInnerHTML={{ __html: errorMessage }} />
                    </div>
                  )}
                  {groups.map((group, groupIndex) => (
                    <div
                      key={group.id}
                      id={`sp-group-${group.id}`}
                      ref={(el) => (sectionRefs.current[groupIndex] = el)}
                      className="mb-4"
                      style={{
                        scrollMarginTop: "80px",
                        background: "#fff",
                        borderRadius: "14px",
                        boxShadow: "0 1px 12px rgba(0,0,0,0.08)",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #e5e9f2",
                          padding: "20px 24px 18px",
                          background: "#fff",
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <h6
                            style={{
                              margin: "0 0 3px",
                              fontWeight: 700,
                              fontSize: "15px",
                              color: "#1c2b46",
                              letterSpacing: "0",
                            }}
                          >
                            Step {groupIndex + 1} — {group.group_title}
                          </h6>
                          {group.group_desc && (
                            <p
                              style={{
                                margin: 0,
                                fontSize: "13px",
                                color: "#8094ae",
                                lineHeight: 1.55,
                              }}
                              dangerouslySetInnerHTML={{ __html: group.group_desc.replace(/\n/g, "<br />") }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="card-inner">
                        <div className="row g-gs">
                          {group.questions
                            .map((qid) => formData[0]?.questions.find((q) => q.id === qid))
                            .filter(Boolean)
                            .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                            .map((question) => {
                              const value = formState[question.id] || question.defaultValue || "";
                              const colClass = getQuestionColClassSP(question, group);
                              const hasFieldError = Boolean(formErrors[question.id]);
                              const errorBorderStyle = hasFieldError
                                ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" }
                                : {};
                              return (
                                <div key={question.id} id={`sp-field-${question.id}`} className={`question-container ${colClass}`}>
                                  <div className="form-group question-text mb-0">
                                    {question.answerType === "label" ? (
                                      <label className="form-label obs-section-label">
                                        {question.questionText}{" "}{question.required && <sup className="text-danger">*</sup>}
                                        {question.tooltip && question.tooltip.trim() !== "" && (
                                          <div className="custom-tooltip-wrapper">
                                            <em className="icon ni ni-info" style={{ color: "#6576ff", marginLeft: "5px", cursor: "pointer", fontSize: "14px" }}></em>
                                            <div className="custom-tooltip-box"><p>{question.tooltip}</p></div>
                                          </div>
                                        )}
                                      </label>
                                    ) : !STATIC_TYPES_SP.includes(question.answerType) ? (
                                      <label className="form-label">
                                        {question.questionText}{" "}{question.required && <sup className="text-danger">*</sup>}
                                        {question.tooltip && question.tooltip.trim() !== "" && (
                                          <div className="custom-tooltip-wrapper">
                                            <em className="icon ni ni-info" style={{ color: "#6576ff", marginLeft: "5px", cursor: "pointer", fontSize: "16px" }}></em>
                                            <div className="custom-tooltip-box"><p>{question.tooltip}</p></div>
                                          </div>
                                        )}
                                      </label>
                                    ) : null}
                                    {question.answerType === "text_only" && (
                                      question.textType === "oli" ? (
                                        <ol style={{ paddingLeft: "20px", marginLeft: "20px" }}>
                                          {question.textOnly.split("\n").filter((l) => l.trim()).map((line, li) => <li key={li} style={{ listStyleType: "decimal", paddingLeft: "10px" }}>{line}</li>)}
                                        </ol>
                                      ) : question.textType === "sli" ? (
                                        <ul style={{ paddingLeft: "20px", marginLeft: "20px" }}>
                                          {question.textOnly.split("\n").filter((l) => l.trim()).map((line, li) => <li key={li} style={{ listStyleType: "disc", paddingLeft: "10px" }}>{line}</li>)}
                                        </ul>
                                      ) : (
                                        <p>{question.textOnly}</p>
                                      )
                                    )}
                                    {question.answerType === "rich_text" && (
                                      <div className="obs-rich-text-scroll">
                                        <div
                                          style={{ fontSize: "14px", lineHeight: 1.65, color: "#526484" }}
                                          dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                        />
                                      </div>
                                    )}
                                    {question.answerType === "notice_text" && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "12px",
                                          alignItems: "flex-start",
                                          background: "#eef3ff",
                                          border: "1px solid #c4d0ff",
                                          borderLeft: "4px solid #6576ff",
                                          borderRadius: "6px",
                                          padding: "14px 16px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        <em
                                          className="icon ni ni-info-fill"
                                          style={{ color: "#6576ff", fontSize: "18px", marginTop: "1px", flexShrink: 0 }}
                                        ></em>
                                        <div
                                          style={{ fontSize: "13.5px", color: "#364a63", lineHeight: 1.6 }}
                                          dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                        />
                                      </div>
                                    )}
                                    {question.answerType === "warning_text" && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "12px",
                                          alignItems: "flex-start",
                                          background: "#fff8ea",
                                          border: "1px solid #ffd591",
                                          borderLeft: "4px solid #f4a600",
                                          borderRadius: "6px",
                                          padding: "14px 16px",
                                          marginBottom: "4px",
                                        }}
                                      >
                                        <em
                                          className="icon ni ni-alert-fill"
                                          style={{ color: "#f4a600", fontSize: "18px", marginTop: "1px", flexShrink: 0 }}
                                        ></em>
                                        <div
                                          style={{ fontSize: "13.5px", color: "#364a63", lineHeight: 1.6 }}
                                          dangerouslySetInnerHTML={{ __html: question.textOnly || "" }}
                                        />
                                      </div>
                                    )}
                                    {question.imageUrl && !STATIC_TYPES_SP.includes(question.answerType) && (
                                      <a onClick={() => downloadPdf(question.imageUrl)} style={{ float: "right", cursor: "pointer" }}>
                                        <span className="badge badge-outline-primary"><em className="icon ni ni-download"></em> Download File</span>
                                      </a>
                                    )}
                                  </div>
                                  {question.imageUrl && question.answerType !== "image_input" && !STATIC_TYPES_SP.includes(question.answerType) && (
                                    <img src={question.imageUrl} alt="Admin Uploaded" className="question-image" />
                                  )}
                                  {question.answerType === "input" && (
                                    <div className="form-group mb-0">
                                      <div className="form-control-wrap address_cont">
                                        {question.validationValue === "validation_phone" ? (
                                          <ReactPhoneInput country="us" specialLabel="" value={formState[question.id] || ""} onChange={(v) => handleChangePhone(question.id, v)} inputStyle={{ width: "100%", height: "42px", ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}) }} buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined} />
                                        ) : question.validationValue === "validation_fulladdress" ? (
                                          <GooglePlacesAutocomplete apiKey={process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY} selectProps={{ value: formState[question.id] ? { label: formState[question.id], value: formState[question.id] } : null, onChange: (addr) => handleAddressSelect(question.id, addr), placeholder: Address ? null : "Enter your address...", styles: { control: (p) => ({ ...p, borderColor: hasFieldError ? "#e85347" : p.borderColor, boxShadow: hasFieldError ? "0 0 0 1px #e85347" : p.boxShadow }), input: (p) => ({ ...p, color: "black" }), option: (p) => ({ ...p, color: "black" }), singleValue: (p) => ({ ...p, color: "black" }), menu: (p) => ({ ...p, zIndex: 9 }) } }} />
                                        ) : question.validationValue === "validation_country" ? (
                                          <Select id="_country_sp" className="customCountrySelect-addClient" name="_country" options={countryOptions} value={country} onChange={(sel) => handleChangeCountry(question.id, sel)} styles={{ control: (p) => ({ ...p, minHeight: "45px", borderColor: hasFieldError ? "#e85347" : p.borderColor, boxShadow: hasFieldError ? "0 0 0 1px #e85347" : p.boxShadow }), menu: (p) => ({ ...p, zIndex: 9 }) }} placeholder="Select Country" />
                                        ) : (
                                          <input className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value, question.inputFormat)} value={formState[question.id] || question.defaultValue || ""} type="text" maxLength={question.maxLength || 100} />
                                        )}
                                      </div>
                                      {question.maxLength && <small className="text-muted" style={{ display: "block", marginTop: "4px" }}>• Maximum length is {question.maxLength} characters.</small>}
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "textarea" && (
                                    <div className="form-group">
                                      <div className="form-control-wrap">
                                        <textarea className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value)} value={formState[question.id] || question.defaultValue || ""} maxLength={question.maxLength || 500} />
                                      </div>
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "datetime" && (
                                    <div className="form-group">
                                      <DateTimePicker variant="inline" inputVariant="outlined" fullWidth format="MM-dd-yyyy hh:mm a" error={hasFieldError} value={formState[question.id] || null} onChange={(d) => handleChange(question.id, d)} />
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "date" && (
                                    <div className="form-group">
                                      <DatePicker variant="inline" inputVariant="outlined" fullWidth format="MM-dd-yyyy" error={hasFieldError} value={formState[question.id] || null} onChange={(d) => handleChange(question.id, d)} />
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "time" && (
                                    <div className="form-group">
                                      <TimePicker variant="inline" inputVariant="outlined" fullWidth error={hasFieldError} value={formState[question.id] || null} onChange={(t) => handleChange(question.id, t)} />
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "dropdown" && (
                                    <div className="form-group">
                                      <div className="form-control-wrap"><div className="form-control-select">
                                        <select className="form-control form-control-lg" style={errorBorderStyle} onChange={(e) => handleChange(question.id, e.target.value)} value={formState[question.id] || question.defaultValue || ""}>
                                          <option value="">Select an option</option>
                                          {question.options.map((opt, oi) => <option key={oi} value={opt}>{opt}</option>)}
                                        </select>
                                      </div></div>
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "checkbox" && (
                                    <div style={{ marginTop: "8px" }}>
                                      {question.options.map((opt, oi) => {
                                        const isChecked = Array.isArray(formState[question.id])
                                          ? formState[question.id].some((v) => v.toLowerCase() === opt.toLowerCase())
                                          : formState[question.id]?.includes(opt) || false;
                                        const hKey = `cb_${question.id}_${oi}`;
                                        const isHovered = hoveredId === hKey;
                                        const showTeal = isChecked ? !isHovered : isHovered;
                                        return (
                                          <label
                                            key={oi}
                                            htmlFor={`sp_cb_${question.id}_${oi}`}
                                            onMouseEnter={() => setHoveredId(hKey)}
                                            onMouseLeave={() => setHoveredId(null)}
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                              gap: "14px",
                                              padding: "14px 16px",
                                              borderRadius: "8px",
                                              border: hasFieldError
                                                ? "1.5px solid #e85347"
                                                : showTeal
                                                  ? "1.5px solid #1ee0ac"
                                                  : "1.5px solid #e5e9f2",
                                              background: showTeal ? "#edfaf6" : "#ffffff",
                                              cursor: "pointer",
                                              transition: "all 0.15s ease",
                                              marginBottom: "10px",
                                              width: "100%",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              className="vdrSelected"
                                              id={`sp_cb_${question.id}_${oi}`}
                                              checked={isChecked}
                                              onChange={(e) => handleCheckboxChange(question.id, opt, e.target.checked)}
                                              style={{
                                                width: "18px",
                                                height: "18px",
                                                flexShrink: 0,
                                                marginTop: "1px",
                                                accentColor: "#1ee0ac",
                                                cursor: "pointer",
                                              }}
                                            />
                                            <span
                                              style={{
                                                fontSize: "13.5px",
                                                color: showTeal ? "#1c2b46" : "#526484",
                                                fontWeight: showTeal ? 600 : 400,
                                                lineHeight: 1.55,
                                                flex: 1,
                                              }}
                                            >
                                              {opt}
                                            </span>
                                          </label>
                                        );
                                      })}
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "radio" && (
                                    <div style={{ marginTop: "8px" }}>
                                      {question.options.map((opt, oi) => {
                                        const isSelected = formState[question.id] === opt;
                                        const hKey = `sp_radio_${question.id}_${oi}`;
                                        const isHovered = hoveredId === hKey;
                                        const showTeal = isSelected || isHovered;
                                        return (
                                          <label
                                            key={oi}
                                            htmlFor={hKey}
                                            onMouseEnter={() => setHoveredId(hKey)}
                                            onMouseLeave={() => setHoveredId(null)}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "14px",
                                              padding: "14px 16px",
                                              borderRadius: "8px",
                                              border: hasFieldError
                                                ? "1.5px solid #e85347"
                                                : showTeal
                                                  ? "1.5px solid #1ee0ac"
                                                  : "1.5px solid #e5e9f2",
                                              background: showTeal ? "#edfaf6" : "#ffffff",
                                              cursor: "pointer",
                                              transition: "all 0.15s ease",
                                              marginBottom: "10px",
                                              width: "100%",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              id={hKey}
                                              name={`sp_radio_${question.id}`}
                                              checked={isSelected}
                                              onChange={() => handleChange(question.id, opt)}
                                              value={opt}
                                              style={{ display: "none" }}
                                            />
                                            <span
                                              style={{
                                                fontSize: "13.5px",
                                                color: showTeal ? "#1c2b46" : "#526484",
                                                fontWeight: showTeal ? 600 : 400,
                                                lineHeight: 1.55,
                                                flex: 1,
                                              }}
                                            >
                                              {opt}
                                            </span>
                                            <span style={{
                                              width: "24px",
                                              height: "24px",
                                              borderRadius: "50%",
                                              background: isSelected ? "#1ee0ac" : "transparent",
                                              border: isSelected ? "none" : "2px solid #d0d5dd",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              flexShrink: 0,
                                              transition: "all 0.15s ease",
                                            }}>
                                              {isSelected && (
                                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                  <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                              )}
                                            </span>
                                          </label>
                                        );
                                      })}
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "image_input" && (
                                    <div className="form-group">
                                      <div className="form-control-group" id="fileContainer">
                                        <input type="file" id={`sp_file_${question.id}`} className="file-block" style={errorBorderStyle} name="add_picture" accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.xlx,.xlxs,.csv" onChange={(e) => handleFileChange(question.id, e)} />
                                        {formState[question.id] && (
                                          <div className="uploaded-file-preview">
                                            {formState[question.id].match(/\.(jpeg|jpg|png)$/i) ? (
                                              <><img src={`${APP_LIVE_URL}files_data/form_response_uploads/${formState[question.id]}`} alt="Uploaded preview" style={{ maxWidth: "100px" }} /><a onClick={() => removeUploadedFile(question.id)} style={{ cursor: "pointer", color: "red", fontSize: "20px", marginLeft: "5px" }} title="Delete"><em className="icon ni ni-trash-fill"></em></a></>
                                            ) : (
                                              <p>{formState[question.id].split("/").pop()}<a onClick={() => removeUploadedFile(question.id)} style={{ cursor: "pointer", color: "red", fontSize: "20px", marginLeft: "5px" }} title="Delete"><em className="icon ni ni-trash-fill"></em></a></p>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                    </div>
                                  )}
                                  {question.answerType === "signature" && (
                                    <>
                                      <ul className="nav nav-tabs">
                                        <li className="nav-item"><a className={signatureType === "draw" || signatureType === "" ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => setSignatureType("draw")} href="#sp-tabDraw"><em className="icon ni ni-edit-alt"></em><span>E-sign</span></a></li>
                                        <li className="nav-item"><a className={signatureType === "choose" ? "nav-link active" : "nav-link"} data-toggle="tab" onClick={() => setSignatureType("choose")} href="#sp-tabChoose"><em className="icon ni ni-list-check"></em><span>Type</span></a></li>
                                      </ul>
                                      <div className="tab-content">
                                        <div className={signatureType === "choose" ? "tab-pane active" : "tab-pane"} id="sp-tabChoose">
                                          <div className="example-alert mb-4"><div className="alert alert-light">On the Type tab, enter your name to generate a live signature preview. You can then choose from the available font styles before saving.</div></div>
                                          <div className="form-group mb-4">
                                            <div className="form-control-wrap">
                                              <input className="form-control form-control-lg" onChange={(e) => handleChangeSignature(question.id, e.target.value)} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={signatureText} type="text" maxLength={100} placeholder="Authorized Person Name" />
                                            </div>
                                            {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                          </div>
                                          <h6 className="title">Choose Style</h6>
                                          <ul className="cc-pay-method">
                                            <li className="cc-pay-dd dropdown">
                                              <a href="#" className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator" data-toggle="dropdown"><span style={{ fontFamily: signatureClass }}>{signatureText || "Your Signature"}</span></a>
                                              <div className="dropdown-menu dropdown-menu-auto">
                                                <ul className="link-list-plain">
                                                  {cursiveFonts.map((font, fi) => (
                                                    <li key={fi}><a style={{ cursor: "pointer" }} onClick={() => setSignatureClass(font.value)} className="cc-pay-item"><span className="cc-pay-item-name"><span className="cc-pay-item-method" style={{ fontFamily: font.value }}>{signatureText !== "" ? signatureText : font.name}</span></span></a></li>
                                                  ))}
                                                </ul>
                                              </div>
                                            </li>
                                          </ul>
                                          <div className="signature-preview mt-3" id={`styled-text-container${question.id}`} style={{ fontFamily: signatureClass, fontSize: "40px", width: "480px", height: "80px", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000" }}>{signatureText || "Your Signature"}</div>
                                          <div className="col-sm-12 mt-4 pl-0" style={{ clear: "both" }}>
                                            <button type="button" className="btn btn-primary" style={{ margin: "13px 0px 12px 0px" }} onClick={() => saveChooseImage(question.id)}><em className="icon ni ni-folder-check"></em> <span>Save Signature</span></button>
                                          </div>
                                        </div>
                                        <div className={signatureType === "draw" || signatureType === "" ? "tab-pane active" : "tab-pane"} id="sp-tabDraw">
                                          <div className="row">
                                            <div className="col-sm-12">
                                              <div className="example-alert mb-4"><div className="alert alert-light">Draw your signature in the box below, then select Save Signature to continue. Clear resets the drawing area.</div></div>
                                              {formState[question.id] && <div className="uploaded-file-preview"><img src={`${APP_LIVE_URL}files_data/form_response_uploads/${formState[question.id]}`} alt="Uploaded Signature" style={{ maxWidth: "200px" }} /></div>}
                                              <div id={`divSig${question.id}`} style={{ display: "none" }}><div className="mb-4"><img src="" className="clsimgSig" height="100" width="200" alt="" /></div></div>
                                              <div><strong>Signature</strong></div>
                                            </div>
                                            <div className="col-sm-12">
                                              <div style={hasFieldError ? { border: "1px solid #e85347", boxShadow: "0 0 0 1px #e85347", borderRadius: "4px", display: "inline-block" } : undefined}>
                                                <SignatureCanvas clearOnResize={true} canvasProps={{ className: styles.sigPad }} velocityFilterWeight={0.7} throttle={50} ref={(ref) => (sigPadRefs.current[question.id] = ref)} />
                                              </div>
                                            </div>
                                            <div className="col-sm-12 mt-4">
                                              <button className="btn btn-warning" style={{ margin: "13px 0px 12px 0px" }} onClick={() => clearSignature(question.id)} type="button"><em className="icon ni ni-delete"></em> <span>Clear</span></button>
                                              <button type="button" className="btn btn-primary" style={{ margin: "13px 0px 12px 10px" }} onClick={() => saveSignature(question.id)}><em className="icon ni ni-folder-check"></em> <span>Save Signature</span></button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {question.answerType === "fixed" && (
                                    <>
                                      <div className="form-group mb-0">
                                        <div className="form-control-wrap">
                                          <input className="form-control form-control-lg" onChange={(e) => handleChangeFixed(question.id, question.answer)} value={question.answer} type="text" maxLength={255} />
                                        </div>
                                        {formErrors[question.id] && <FormHelperText error>{formErrors[question.id]}</FormHelperText>}
                                      </div>
                                      <CopyToClipboard text={question.answer} onCopy={() => setCopied(true)} style={{ cursor: "pointer" }}>
                                        <div className="form-note text-primary"><strong>Copy to Clipboard {copied ? <span><em className="icon ni ni-done"></em></span> : null}</strong></div>
                                      </CopyToClipboard>
                                    </>
                                  )}
                                  {question.answerType === "label" && <div className="form-group mb-0"><h6></h6></div>}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  ))}
                  {captcha_enabled === 1 && link_form !== 1 && (
                    <div className="captcha-section" style={{ marginTop: "20px", marginBottom: "10px" }}>
                      <ReCAPTCHA ref={captchaRef} sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY} onChange={handleCaptchaChange} onExpired={handleCaptchaExpired} />
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "12px",
                      padding: "18px 0 4px",
                      marginTop: "12px",
                      borderTop: "1px solid #e5e9f2",
                    }}
                  >
                    {allow_submit === 1 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitSinglePage}
                        disabled={loading || isFormInReviewMode}
                        style={{
                          minWidth: "160px",
                          height: "42px",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "14px",
                          textTransform: "none",
                          letterSpacing: "0.02em",
                          background: loading || isFormInReviewMode ? undefined : "#1c2b46",
                          boxShadow: "0 2px 10px rgba(28,43,70,0.3)",
                        }}
                      >
                        {loading ? (
                          "Submitting..."
                        ) : (
                          <>
                            <em className="icon ni ni-check-thick" style={{ marginRight: "6px" }}></em>
                            Submit Form
                          </>
                        )}
                      </Button>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "10px 16px",
                          borderRadius: "6px",
                          background: "#fff8ea",
                          border: "1px solid #ffd591",
                          color: "#8a6c00",
                          fontSize: "13.5px",
                          fontWeight: 500,
                        }}
                      >
                        <em className="icon ni ni-lock" style={{ fontSize: "16px" }}></em>
                        Submission is disabled for this form.
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* ── Phase 2 end. Old wizard flow disabled below for reference ── */}
              {false && (currentGroup ? (
                <>
                  <div className="card">
                    <div className="card-inner">
                    <div className="mb-5" style={{ background: "#fff" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <div className="nk-kycfm-title">
                          <h5 className="title">
                            {formTitle || "Untitled Form"}
                          </h5>
                          {currentStep === 0 && (
                            <p className="sub-title">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formDescription,
                                }}
                              />
                            </p>
                          )}
                        </div>
                      </div>
                      {service_data && service_data.length ? (
                        <div className="card card-bordered mt-5">
                          <div className="card-inner">
                            <div className="sp-plan-head">
                              <h4 className="title">Form Services</h4>
                            </div>
                            <p>
                              This form is linked to the following services.
                              Submitting it will also generate an order for the
                              selected products listed below. If you do not wish
                              to create an order or remove any product from the
                              order, please uncheck the services.
                            </p>
                            <ul className="nk-kycfm-control-list g-3">
                              {service_data?.map(([id, name]) => (
                                <li
                                  className="nk-kycfm-control-item"
                                  key={`ser-${id}`}
                                >
                                  <input
                                    id={`service-${id}`}
                                    checked={selectedServices.includes(id)}
                                    onChange={() => handleCheckboxChangeNew(id)}
                                    className="nk-kycfm-control"
                                    type="checkbox"
                                    name={name}
                                    data-title={name}
                                    value="Yes"
                                  />
                                  <label
                                    className="nk-kycfm-label"
                                    htmlFor={`service-${id}`}
                                  >
                                    <span className="nk-kycfm-label-icon">
                                      <div className="label-icon">
                                        <em
                                          className="icon ni ni-card-view fs26px"
                                          style={{ marginRight: "15px" }}
                                        ></em>
                                      </div>
                                    </span>
                                    <span className="nk-kycfm-label-text">
                                      {name}
                                    </span>
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <form
                      autoComplete="off"
                      action="#"
                      className="nk-wizard nk-wizard-simple is-alter wizard clearfix"
                      id="wizard-01"
                      role="application"
                      novalidate="novalidate"
                    >
                      <div className="steps clearfix">
                        <ul role="tablist" className="">
                          {groups.map((group, index) => {
                            const isCurrent = currentStep === index;
                            const isCompleted = currentStep > index;
                            const isDisabled = currentStep < index;

                            return (
                              <li
                                key={group.id}
                                role="tab"
                                className={`${isCurrent ? "current" : ""} ${
                                  isDisabled ? "disabled" : ""
                                } ${index === 0 ? "first" : ""} ${
                                  index === groups.length - 1 ? "last" : ""
                                } ${isCompleted ? "done" : ""}`}
                                aria-disabled={isDisabled}
                                aria-selected={isCurrent}
                                style={{ marginBottom: "0.725rem" }}
                              >
                                <div
                                  id={`wizard-01-t-${index}`}
                                  aria-controls={`wizard-01-p-${index}`}
                                >
                                  {isCurrent && (
                                    <span className="current-info audible">
                                      current step:{" "}
                                    </span>
                                  )}
                                  <span className="number">
                                    {String(index + 1).padStart(2, "0")}
                                  </span>
                                  <h5>{group.group_title}</h5>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <div className="nk-stepper-content">
                          <div className="nk-stepper-steps stepper-steps">
                            <div className="nk-kycfm">
                              <div className="">
                                {responseMessage && (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: responseMessage,
                                    }}
                                  ></div>
                                )}
                                {errorMessage && (
                                  <div className="alert alert-danger alert-icon mb-3">
                                    <em className="icon ni ni-cross-circle"></em>{" "}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: errorMessage,
                                      }}
                                    ></div>
                                  </div>
                                )}
                                <div className="mb-3">
                                  <h5 className="title">
                                    {currentGroup.group_title}
                                  </h5>
                                  <p
                                    className="sub-title"
                                    dangerouslySetInnerHTML={{
                                      __html: currentGroup.group_desc
                                        ? currentGroup.group_desc.replace(
                                            /\n/g,
                                            "<br />",
                                          )
                                        : "",
                                    }}
                                  ></p>
                                </div>
                                <div className="row g-gs">
                                  {/*currentGroup.questions.map((questionId) => {
                          const question = formData[0].questions.find(
                            (q) => q.id === questionId
                          );
                          if (!question) {
                            return null;
                          }*/}

                                  {currentGroup.questions
                                    .map((questionId) => {
                                      // Find the corresponding question from formData
                                      const question =
                                        formData[0].questions.find(
                                          (q) => q.id === questionId,
                                        );
                                      return question;
                                    })
                                    .filter(Boolean) // Remove any undefined values if a question is not found
                                    .sort(
                                      (a, b) =>
                                        a.sequenceNumber - b.sequenceNumber,
                                    ) // Sort by sequence number
                                    .map((question) => {
                                      const value =
                                        formState[question.id] ||
                                        question.defaultValue ||
                                        "";

                                      return (
                                        <div
                                          key={question.id}
                                          className={
                                            question.answerType === "label" ||
                                            question.answerType === "text_only"
                                              ? "question-container col-sm-12"
                                              : "question-container col-sm-6"
                                          }
                                        >
                                          <div className="form-group question-text mb-0">
                                            {question.answerType === "label" ? (
                                              <label
                                                className="form-label"
                                                style={{
                                                  fontSize: "1.275rem",
                                                }}
                                              >
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                question.tooltip.trim() !==
                                                  "" ? (
                                                  <div className="custom-tooltip-wrapper">
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        fontSize: "16px",
                                                      }}
                                                    ></em>
                                                    <div className="custom-tooltip-box">
                                                      <p>{question.tooltip}</p>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </label>
                                            ) : (
                                              <>
                                                {question.answerType !==
                                                "text_only" ? (
                                                  <label className="form-label">
                                                    {question.questionText}{" "}
                                                    {question.required && (
                                                      <sup className="text-danger">
                                                        *
                                                      </sup>
                                                    )}
                                                    {question.tooltip &&
                                                    question.tooltip.trim() !==
                                                      "" ? (
                                                      <div className="custom-tooltip-wrapper">
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                            marginLeft: "5px",
                                                            cursor: "pointer",
                                                            fontSize: "16px",
                                                          }}
                                                        ></em>
                                                        <div className="custom-tooltip-box">
                                                          <p>
                                                            {question.tooltip}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </label>
                                                ) : null}
                                              </>
                                            )}
                                            {question.answerType ===
                                            "text_only" ? (
                                              <>
                                                {question.textType === "p" ? (
                                                  <p>{question.textOnly} </p>
                                                ) : question.textType ===
                                                  "oli" ? (
                                                  <ol
                                                    style={{
                                                      paddingLeft: "20px",
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    {question.textOnly
                                                      .split("\n")
                                                      .filter(
                                                        (line) =>
                                                          line.trim() !== "",
                                                      )
                                                      .map((line, index) => (
                                                        <li
                                                          key={index}
                                                          style={{
                                                            listStyleType:
                                                              "decimal",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {line}
                                                        </li>
                                                      ))}
                                                  </ol>
                                                ) : question.textType ===
                                                  "sli" ? (
                                                  <ul
                                                    style={{
                                                      paddingLeft: "20px",
                                                      marginLeft: "20px",
                                                    }}
                                                  >
                                                    {question.textOnly
                                                      .split("\n")
                                                      .filter(
                                                        (line) =>
                                                          line.trim() !== "",
                                                      )
                                                      .map((line, index) => (
                                                        <li
                                                          key={index}
                                                          style={{
                                                            listStyleType:
                                                              "disc",
                                                            paddingLeft: "10px",
                                                          }}
                                                        >
                                                          {line}
                                                        </li>
                                                      ))}
                                                  </ul>
                                                ) : (
                                                  <p>{question.textOnly} </p>
                                                )}
                                              </>
                                            ) : null}
                                            {question.imageUrl && (
                                              <>
                                                <a
                                                  onClick={() =>
                                                    downloadPdf(
                                                      question.imageUrl,
                                                    )
                                                  }
                                                  style={{
                                                    float: "right",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <span className="badge badge-outline-primary">
                                                    <em className="icon ni ni-download"></em>{" "}
                                                    Download File
                                                  </span>
                                                </a>
                                              </>
                                            )}
                                          </div>

                                          {question.answerType === "input" && (
                                            <div className="form-group mb-0">
                                              <div className="form-control-wrap address_cont">
                                                {/* Phone validation */}
                                                {question.validationValue ===
                                                "validation_phone" ? (
                                                  <ReactPhoneInput
                                                    country="us"
                                                    specialLabel=""
                                                    value={formState[question.id] || ""}
                                                    onChange={(v) => handleChangePhone(question.id, v)}
                                                    inputStyle={{
                                                      width: "100%",
                                                      height: "42px",
                                                      ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}),
                                                    }}
                                                    buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined}
                                                  />
                                                ) : question.validationValue ===
                                                  "validation_fulladdress" ? (
                                                  <GooglePlacesAutocomplete
                                                    apiKey={
                                                      process.env
                                                        .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                    }
                                                    selectProps={{
                                                      value: formState[
                                                        question.id
                                                      ]
                                                        ? {
                                                            label:
                                                              formState[
                                                                question.id
                                                              ],
                                                            value:
                                                              formState[
                                                                question.id
                                                              ],
                                                          }
                                                        : null,
                                                      onChange: (address) =>
                                                        handleAddressSelect(
                                                          question.id,
                                                          address,
                                                        ),
                                                      placeholder: Address
                                                        ? null
                                                        : "Enter your address...",
                                                      styles: {
                                                        input: (provided) => ({
                                                          ...provided,
                                                          color: "black",
                                                          minHeigh: "40px",
                                                        }),
                                                        option: (provided) => ({
                                                          ...provided,
                                                          color: "black",
                                                        }),
                                                        singleValue: (
                                                          provided,
                                                        ) => ({
                                                          ...provided,
                                                          color: "black",
                                                        }),
                                                        menu: (provided) => ({
                                                          ...provided,
                                                          zIndex: 9,
                                                        }),
                                                      },
                                                    }}
                                                  />
                                                ) : question.validationValue ===
                                                  "validation_country" ? (
                                                  <Select
                                                    id="_country"
                                                    className="customCountrySelect-addClient"
                                                    name="_country"
                                                    label="Country"
                                                    options={countryOptions}
                                                    value={country}
                                                    onChange={(
                                                      selectedOption,
                                                    ) =>
                                                      handleChangeCountry(
                                                        question.id,
                                                        selectedOption,
                                                      )
                                                    }
                                                    styles={{
                                                      control: (provided) => ({
                                                        ...provided,
                                                        minHeight: "45px",
                                                      }),
                                                      menu: (
                                                        provided,
                                                        state,
                                                      ) => ({
                                                        ...provided,
                                                        zIndex: 9,
                                                      }),
                                                    }}
                                                    placeholder="Select Country"
                                                  />
                                                ) : (
                                                  <input
                                                    className="form-control form-control-lg"
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                        question.inputFormat,
                                                      )
                                                    }
                                                    value={value}
                                                    type="text"
                                                    maxLength={
                                                      question.maxLength || 100
                                                    }
                                                  />
                                                )}
                                              </div>
                                              <div
                                                className="helper-text"
                                                style={{ marginTop: "6px" }}
                                              >
                                                {question.maxLength && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Maximum length is{" "}
                                                    {question.maxLength}{" "}
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "number_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only numbers are allowed
                                                    (e.g. 123456).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphabet_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphabets are allowed
                                                    (e.g. JohnDoe).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphanumeric" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphanumeric characters
                                                    are allowed (e.g. John123).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "open" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    You can enter any
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                              </div>

                                              {/* Display form errors if present */}
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "signature" && (
                                            <>
                                              <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                  <a
                                                    className={
                                                      signatureType ===
                                                        "draw" ||
                                                      signatureType === ""
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                    }
                                                    data-toggle="tab"
                                                    onClick={() =>
                                                      setSignatureType("draw")
                                                    }
                                                    href="#tabItem6"
                                                  >
                                                    <em className="icon ni ni-edit-alt"></em>
                                                    <span>Draw</span>
                                                  </a>
                                                </li>
                                                <li className="nav-item">
                                                  <a
                                                    className={
                                                      signatureType === "choose"
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                    }
                                                    data-toggle="tab"
                                                    onClick={() =>
                                                      setSignatureType("choose")
                                                    }
                                                    href="#tabItem5"
                                                  >
                                                    <em className="icon ni ni-list-check"></em>
                                                    <span>Choose</span>
                                                  </a>
                                                </li>
                                              </ul>
                                              <div className="tab-content">
                                                <div
                                                  className={
                                                    signatureType === "choose"
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem5"
                                                >
                                                  <div className="example-alert mb-4">
                                                    <div className="alert alert-light">
                                                      Pick a style for your
                                                      signature (Authorized
                                                      Person Name).
                                                    </div>
                                                  </div>
                                                  <div className="form-group mb-4">
                                                    <div className="form-control-wrap">
                                                      <input
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChangeSignature(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        onInput={(e) => {
                                                          e.target.value =
                                                            e.target.value.replace(
                                                              /[^a-zA-Z0-9 ]/gi,
                                                              "",
                                                            );
                                                        }}
                                                        value={signatureText}
                                                        type="text"
                                                        maxLength={100}
                                                        placeholder="Authorized Person Name"
                                                      />
                                                    </div>
                                                    {formErrors[
                                                      question.id
                                                    ] && (
                                                      <FormHelperText error>
                                                        {
                                                          formErrors[
                                                            question.id
                                                          ]
                                                        }
                                                      </FormHelperText>
                                                    )}
                                                  </div>

                                                  <h6 className="title">
                                                    Choose Style
                                                  </h6>

                                                  <ul className="cc-pay-method">
                                                    <li className="cc-pay-dd dropdown">
                                                      <a
                                                        href="#"
                                                        className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                                        data-toggle="dropdown"
                                                      >
                                                        <span
                                                          style={{
                                                            fontFamily:
                                                              signatureClass,
                                                          }}
                                                        >
                                                          {signatureText ||
                                                            "Your Signature"}
                                                        </span>
                                                      </a>
                                                      <div className="dropdown-menu dropdown-menu-auto">
                                                        <ul className="link-list-plain">
                                                          {cursiveFonts.map(
                                                            (font, index) => (
                                                              <li key={index}>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    setSignatureClass(
                                                                      font.value,
                                                                    )
                                                                  }
                                                                  className="cc-pay-item"
                                                                >
                                                                  <span className="cc-pay-item-name">
                                                                    <span
                                                                      className="cc-pay-item-method"
                                                                      style={{
                                                                        fontFamily:
                                                                          font.value,
                                                                      }}
                                                                    >
                                                                      {signatureText !==
                                                                      ""
                                                                        ? signatureText
                                                                        : font.name}
                                                                    </span>
                                                                  </span>
                                                                </a>
                                                              </li>
                                                            ),
                                                          )}
                                                        </ul>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                  <div
                                                    className="signature-preview mt-3"
                                                    id={`styled-text-container${question.id}`}
                                                    style={{
                                                      fontFamily:
                                                        signatureClass,
                                                      fontSize: "40px",
                                                      width: "480px",
                                                      height: "80px",
                                                      background:
                                                        "trasnparent",
                                                      backgroundColor:
                                                        "transparent",
                                                      border: "none",
                                                      lineHeight: "80px",
                                                      color: "#000",
                                                    }}
                                                  >
                                                    {signatureText ||
                                                      "Your Signature"}
                                                  </div>

                                                  <div
                                                    className="col-sm-12 mt-4 pl-0"
                                                    style={{
                                                      clear: "both",
                                                    }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary"
                                                      style={{
                                                        margin:
                                                          "13px 0px 12px 0px",
                                                      }}
                                                      onClick={() =>
                                                        saveChooseImage(
                                                          question.id,
                                                        )
                                                      }
                                                    >
                                                      <em className="icon ni ni-folder-check"></em>{" "}
                                                      <span>
                                                        Save Signature
                                                      </span>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    signatureType === "draw" ||
                                                    signatureType === ""
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem6"
                                                >
                                                  <div className="row">
                                                    <div className="col-sm-12">
                                                      <div className="example-alert mb-4">
                                                        <div className="alert alert-light">
                                                          Please Save the
                                                          signature to proceed.
                                                        </div>
                                                      </div>
                                                      {formState[
                                                        question.id
                                                      ] && (
                                                        <div className="uploaded-file-preview">
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded Signature"
                                                            style={{
                                                              maxWidth: "200px",
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                      <div
                                                        id={`divSig${question.id}`}
                                                        style={{
                                                          display: "none",
                                                        }}
                                                      >
                                                        <div className="mb-4">
                                                          <img
                                                            src=""
                                                            className="clsimgSig"
                                                            height="100"
                                                            width="200"
                                                            onerror="this.style.display='none'"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div>
                                                        <strong>
                                                          Signature
                                                        </strong>
                                                      </div>
                                                    </div>

                                                    <div className="col-sm-12">
                                                      <SignatureCanvas
                                                        clearOnResize={true}
                                                        canvasProps={{
                                                          className:
                                                            styles.sigPad,
                                                        }}
                                                        velocityFilterWeight={
                                                          0.7
                                                        }
                                                        throttle={50}
                                                        ref={(ref) =>
                                                          (sigPadRefs.current[
                                                            question.id
                                                          ] = ref)
                                                        }
                                                      />
                                                    </div>
                                                    <div className="col-sm-12 mt-4">
                                                      <button
                                                        className="btn btn-warning"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 0px",
                                                        }}
                                                        onClick={() =>
                                                          clearSignature(
                                                            question.id,
                                                          )
                                                        }
                                                        type="button"
                                                      >
                                                        <em className="icon ni ni-delete"></em>{" "}
                                                        <span>Clear</span>
                                                      </button>
                                                      {/*<button
                                            className="btn btn-success"
                                            style={{
                                              margin: "13px 0px 12px 10px",
                                            }}
                                            type="button"
                                            onClick={() =>
                                              previewSignature(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-eye"></em>{" "}
                                            <span>Preview</span>
                                          </button>*/}
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 10px",
                                                        }}
                                                        onClick={() =>
                                                          saveSignature(
                                                            question.id,
                                                          )
                                                        }
                                                      >
                                                        <em className="icon ni ni-folder-check"></em>{" "}
                                                        <span>
                                                          Save Signature
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          {question.answerType === "fixed" && (
                                            <>
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChangeFixed(
                                                        question.id,
                                                        question.answer,
                                                      )
                                                    }
                                                    value={question.answer}
                                                    type="text"
                                                    maxLength={255}
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                              <CopyToClipboard
                                                text={question.answer}
                                                onCopy={() => setCopied(true)}
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <div className="form-note text-primary">
                                                  <strong>
                                                    Copy to Clipboard{" "}
                                                    {copied ? (
                                                      <span>
                                                        <em className="icon ni ni-done"></em>
                                                      </span>
                                                    ) : null}
                                                  </strong>
                                                </div>
                                              </CopyToClipboard>
                                            </>
                                          )}
                                          {question.answerType === "label" && (
                                            <div className="form-group mb-0">
                                              <h6></h6>
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "textarea" && (
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <textarea
                                                  className={`form-control form-control-lg`}
                                                  onChange={(e) =>
                                                    handleChange(
                                                      question.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder=""
                                                  value={value}
                                                  maxLength={
                                                    question.maxLength || 500
                                                  }
                                                ></textarea>
                                              </div>
                                              <div
                                                className="helper-text"
                                                style={{ marginTop: "6px" }}
                                              >
                                                {question.maxLength && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Maximum length is{" "}
                                                    {question.maxLength}{" "}
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "number_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only numbers are allowed
                                                    (e.g. 123456).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphabet_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphabets are allowed
                                                    (e.g. JohnDoe).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphanumeric" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphanumeric characters
                                                    are allowed (e.g. John123).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "open" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    You can enter any
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "datetime" && (
                                            <div className="form-group">
                                              <DateTimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="MM-dd-yyyy hh:mm a"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "date" && (
                                            <div className="form-group">
                                              <DatePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="MM-dd-yyyy"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "time" && (
                                            <div className="form-group">
                                              <TimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(time) =>
                                                  handleChange(
                                                    question.id,
                                                    time,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "dropdown" && (
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div className="form-control-select">
                                                  <select
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    value={value}
                                                  >
                                                    <option value="">
                                                      Select an option
                                                    </option>
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <option
                                                          key={index}
                                                          value={option}
                                                        >
                                                          {option}
                                                        </option>
                                                      ),
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "checkbox" && (
                                            <>
                                              <div className="mt-2 prettyprint ">
                                                <div className="row">
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <div
                                                        className="col-md-12 mb-1"
                                                        key={`options_${index}`}
                                                      >
                                                        <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                          <input
                                                            type="checkbox"
                                                            className="custom-control-input vdrSelected"
                                                            id={`question_checkbox_${question.id}_${index}`}
                                                            checked={
                                                              (Array.isArray(formState[question.id])
                                                                ? formState[question.id].some((v) => v.toLowerCase() === option.toLowerCase())
                                                                : formState[question.id]?.includes(option)) || false
                                                            }
                                                            onChange={(e) =>
                                                              handleCheckboxChange(
                                                                question.id,
                                                                option,
                                                                e.target
                                                                  .checked,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`question_checkbox_${question.id}_${index}`}
                                                          >
                                                            {option}
                                                          </label>
                                                        </div>
                                                        {formErrors[
                                                          question.id
                                                        ] && (
                                                          <FormHelperText error>
                                                            {
                                                              formErrors[
                                                                question.id
                                                              ]
                                                            }
                                                          </FormHelperText>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          )}

                                          {question.answerType === "radio" && (
                                            <div style={{ marginTop: "8px" }}>
                                              {question.options.map(
                                                (option, index) => {
                                                  const isSelected = formState[question.id] === option;
                                                  const hKey = `radio_${question.id}_${index}`;
                                                  const isHovered = hoveredId === hKey;
                                                  const showTeal = isSelected || isHovered;
                                                  return (
                                                    <label
                                                      key={index}
                                                      htmlFor={hKey}
                                                      onMouseEnter={() => setHoveredId(hKey)}
                                                      onMouseLeave={() => setHoveredId(null)}
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "14px",
                                                        padding: "14px 16px",
                                                        borderRadius: "8px",
                                                        border: showTeal ? "1.5px solid #1ee0ac" : "1.5px solid #e5e9f2",
                                                        background: showTeal ? "#edfaf6" : "#ffffff",
                                                        cursor: "pointer",
                                                        transition: "all 0.15s ease",
                                                        marginBottom: "10px",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      <input
                                                        type="radio"
                                                        id={hKey}
                                                        name={`radio_${question.id}`}
                                                        checked={isSelected}
                                                        onChange={() => handleChange(question.id, option)}
                                                        value={option}
                                                        style={{ display: "none" }}
                                                      />
                                                      <span
                                                        style={{
                                                          fontSize: "13.5px",
                                                          color: showTeal ? "#1c2b46" : "#526484",
                                                          fontWeight: showTeal ? 600 : 400,
                                                          lineHeight: 1.55,
                                                          flex: 1,
                                                        }}
                                                      >
                                                        {option}
                                                      </span>
                                                      <span style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        borderRadius: "50%",
                                                        background: isSelected ? "#1ee0ac" : "transparent",
                                                        border: isSelected ? "none" : "2px solid #d0d5dd",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        flexShrink: 0,
                                                        transition: "all 0.15s ease",
                                                      }}>
                                                        {isSelected && (
                                                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                            <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                          </svg>
                                                        )}
                                                      </span>
                                                    </label>
                                                  );
                                                },
                                              )}
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "image_input" && (
                                            <div className="form-group">
                                              <div
                                                className="form-control-group"
                                                id="fileContainer"
                                              >
                                                <input
                                                  type="file"
                                                  id={`add_picture_${question.id}`}
                                                  className="file-block"
                                                  name="add_picture"
                                                  accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                  onChange={(e) =>
                                                    handleFileChange(
                                                      question.id,
                                                      e,
                                                    )
                                                  }
                                                />
                                                {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                {formState[question.id] && (
                                                  <div className="uploaded-file-preview">
                                                    {formState[
                                                      question.id
                                                    ].match(
                                                      /\.(jpeg|jpg|png)$/i,
                                                    ) ? (
                                                      <>
                                                        <img
                                                          src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                            formState[
                                                              question.id
                                                            ]
                                                          }`}
                                                          alt="Uploaded preview"
                                                          style={{
                                                            maxWidth: "100px",
                                                          }}
                                                        />
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <p>
                                                        {formState[question.id]
                                                          .split("/")
                                                          .pop()}
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </p> // Display file name for non-images
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* CAPTCHA Section - Show on last step for multi-step forms or on single-step forms */}
                      {shouldShowCaptcha && (
                        <div
                          className="captcha-section"
                          style={{
                            marginTop: "20px",
                            marginBottom: "10px",
                          }}
                        >
                          <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                            onExpired={handleCaptchaExpired}
                          />
                        </div>
                      )}
                      <div
                        className="actions clearfix border-top"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "30px",
                        }}
                      >
                        <ul
                          role="menu"
                          aria-label="Pagination"
                          className="mt-4"
                        >
                          {currentStep > 0 && (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => setCurrentStep(currentStep - 1)}
                              style={{
                                marginBottom: "10px",
                                marginTop: "10px",
                              }}
                              className="back-button-mobile"
                            >
                              Back
                            </Button>
                          )}
                          {allowSkip === 1 &&
                            isOnboarding &&
                            isFilled !== 1 &&
                            isSkipped !== 1 && (
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={onSkipStep}
                                style={{
                                  marginLeft: "10px",
                                  marginBottom: "10px",
                                  marginTop: "10px",
                                }}
                                className="skip-button-mobile"
                              >
                                <em className="icon ni ni-forward"></em> Skip
                                This Step
                              </Button>
                            )}
                          {(isFilled === 1 || isSkipped === 1) && (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={onNextStep}
                              style={{
                                marginLeft: "10px",
                                marginBottom: "10px",
                                marginTop: "10px",
                              }}
                              className="skip-button-mobile"
                            >
                              <em className="icon ni ni-forward"></em> Next Step
                            </Button>
                          )}
                          {currentStep < groups.length - 1 ? (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleNextStep}
                              style={{ marginLeft: "10px" }}
                              disabled={loading || isFormInReviewMode}
                            >
                              Save & Continue
                            </Button>
                          ) : (
                            <>
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{
                                    marginLeft: "10px",
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                    width: "150px",
                                  }}
                                  disabled={loading}
                                >
                                  {loading ? "Loading..." : "Save & Finish"}
                                </Button>
                              )}
                              {allow_submit === 0 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-warning"
                                  style={{
                                    marginLeft: "10px",
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                  }}
                                >
                                  Submission is disabled for this form.
                                </button>
                              )}
                            </>
                          )}
                        </ul>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            ) : (
              hasUngroupedQuestions && (
                <>
                  <div className="nk-block nk-block-lg">
                    <div className="card">
                      <form
                        autoComplete="off"
                        className="nk-stepper stepper-init is-alter nk-stepper-s1"
                        action="#"
                        id="stepper-create-project"
                        data-step-current="2"
                        noValidate
                        style={{ display: "block" }}
                      >
                        <div className="row g-0 col-sep col-sep-md col-sep-xl">
                          <div className="col-md-3 col-xl-3">
                            <div className="card-inner">
                              <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                                {groups.map((group, index) => (
                                  <li
                                    key={group.id}
                                    className={
                                      currentStep === index
                                        ? "current"
                                        : currentStep > index
                                          ? "done"
                                          : ""
                                    }
                                  >
                                    <div className="step-item">
                                      <div className="step-text">
                                        <div className="lead-text">
                                          {group.group_title}
                                        </div>
                                        <div
                                          className="sub-text"
                                          dangerouslySetInnerHTML={{
                                            __html: group.group_desc,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>

                          <div className="col-md-9 col-xl-9">
                            <div className="card-inner">
                              <div className="nk-stepper-content">
                                <div className="nk-stepper-steps stepper-steps">
                                  <div className="nk-kycfm">
                                    <div
                                      className="nk-kycfm-head"
                                      style={{ background: "#f5f6fa" }}
                                    >
                                      <div className="nk-kycfm-title">
                                        <h5 className="title">
                                          {formTitle || "Untitled Form"}
                                        </h5>
                                        <p className="sub-title">
                                          {formDescription || "Untitled Form"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="nk-kycfm-content">
                                      {responseMessage && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: responseMessage,
                                          }}
                                        ></div>
                                      )}
                                      {errorMessage && (
                                        <div className="alert alert-danger alert-icon mb-3">
                                          <em className="icon ni ni-cross-circle"></em>{" "}
                                          Please fill out all the required
                                          questions!
                                        </div>
                                      )}
                                      <div className="row g-gs">
                                        {ungroupedQuestions.map((question) => (
                                          <div
                                            key={question.id}
                                            className="question-container col-sm-6"
                                          >
                                            <div className="form-group question-text mb-0">
                                              <label className="form-label">
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                question.tooltip.trim() !==
                                                  "" ? (
                                                  <div className="custom-tooltip-wrapper">
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        fontSize: "16px",
                                                      }}
                                                    ></em>
                                                    <div className="custom-tooltip-box">
                                                      <p>{question.tooltip}</p>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </label>
                                            </div>
                                            {question.imageUrl && (
                                              <img
                                                src={question.imageUrl}
                                                alt="Admin Uploaded"
                                                className="question-image"
                                              />
                                            )}
                                            {question.answerType ===
                                              "input" && (
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    type="text"
                                                    maxLength={
                                                      question.maxLength || 100
                                                    }
                                                    value={
                                                      formState[question.id] ||
                                                      question.defaultValue ||
                                                      ""
                                                    }
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "textarea" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <textarea
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    placeholder=""
                                                    maxLength={
                                                      question.maxLength || 500
                                                    }
                                                    value={
                                                      formState[question.id] ||
                                                      question.defaultValue ||
                                                      ""
                                                    }
                                                  ></textarea>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "datetime" && (
                                              <div className="form-group">
                                                <DateTimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy hh:mm a"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "date" && (
                                              <div className="form-group">
                                                <DatePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "time" && (
                                              <div className="form-group">
                                                <TimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(time) =>
                                                    handleChange(
                                                      question.id,
                                                      time,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "dropdown" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <div className="form-control-select">
                                                    <select
                                                      className={`form-control form-control-lg`}
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      value={
                                                        formState[
                                                          question.id
                                                        ] ||
                                                        question.defaultValue ||
                                                        ""
                                                      }
                                                    >
                                                      <option value="">
                                                        Select an option
                                                      </option>
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option}
                                                          >
                                                            {option}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "checkbox" && (
                                              <>
                                                <div className="mt-2 prettyprint ">
                                                  <div className="row">
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <div
                                                          className="col-md-6 mb-1"
                                                          key={`options_${index}`}
                                                        >
                                                          <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                            <input
                                                              type="checkbox"
                                                              className="custom-control-input vdrSelected"
                                                              id={`question_checkbox_${question.id}_${index}`}
                                                              checked={
                                                                (Array.isArray(formState[question.id])
                                                                  ? formState[question.id].some((v) => v.toLowerCase() === option.toLowerCase())
                                                                  : formState[question.id]?.includes(option)) || false
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxChange(
                                                                  question.id,
                                                                  option,
                                                                  e.target
                                                                    .checked,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor={`question_checkbox_${question.id}_${index}`}
                                                            >
                                                              {option}
                                                            </label>
                                                          </div>
                                                          {formErrors[
                                                            question.id
                                                          ] && (
                                                            <FormHelperText
                                                              error
                                                            >
                                                              {
                                                                formErrors[
                                                                  question.id
                                                                ]
                                                              }
                                                            </FormHelperText>
                                                          )}
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              </>
                                            )}

                                            {question.answerType ===
                                              "radio" && (
                                              <div style={{ marginTop: "8px" }}>
                                                {question.options.map(
                                                  (option, index) => {
                                                    const isSelected = formState[question.id] === option;
                                                    const hKey = `radio_${question.id}_${index}`;
                                                    const isHovered = hoveredId === hKey;
                                                    const showTeal = isSelected || isHovered;
                                                    return (
                                                      <label
                                                        key={index}
                                                        htmlFor={hKey}
                                                        onMouseEnter={() => setHoveredId(hKey)}
                                                        onMouseLeave={() => setHoveredId(null)}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "14px",
                                                          padding: "14px 16px",
                                                          borderRadius: "8px",
                                                          border: showTeal ? "1.5px solid #1ee0ac" : "1.5px solid #e5e9f2",
                                                          background: showTeal ? "#edfaf6" : "#ffffff",
                                                          cursor: "pointer",
                                                          transition: "all 0.15s ease",
                                                          marginBottom: "10px",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={hKey}
                                                          name={`radio_${question.id}`}
                                                          checked={isSelected}
                                                          onChange={() => handleChange(question.id, option)}
                                                          value={option}
                                                          style={{ display: "none" }}
                                                        />
                                                        <span
                                                          style={{
                                                            fontSize: "13.5px",
                                                            color: showTeal ? "#1c2b46" : "#526484",
                                                            fontWeight: showTeal ? 600 : 400,
                                                            lineHeight: 1.55,
                                                            flex: 1,
                                                          }}
                                                        >
                                                          {option}
                                                        </span>
                                                        <span style={{
                                                          width: "24px",
                                                          height: "24px",
                                                          borderRadius: "50%",
                                                          background: isSelected ? "#1ee0ac" : "transparent",
                                                          border: isSelected ? "none" : "2px solid #d0d5dd",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent: "center",
                                                          flexShrink: 0,
                                                          transition: "all 0.15s ease",
                                                        }}>
                                                          {isSelected && (
                                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                              <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                          )}
                                                        </span>
                                                      </label>
                                                    );
                                                  },
                                                )}
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "image_input" && (
                                              <div className="form-group">
                                                <div
                                                  className="form-control-group"
                                                  id="fileContainer"
                                                >
                                                  <input
                                                    type="file"
                                                    id={`add_picture_${question.id}`}
                                                    className="file-block"
                                                    name="add_picture"
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                    onChange={(e) =>
                                                      handleFileChange(
                                                        question.id,
                                                        e,
                                                      )
                                                    }
                                                  />
                                                  {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                  {formState[question.id] && (
                                                    <div className="uploaded-file-preview">
                                                      {formState[
                                                        question.id
                                                      ].match(
                                                        /\.(jpeg|jpg|png)$/i,
                                                      ) ? (
                                                        <>
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded preview"
                                                            style={{
                                                              maxWidth: "100px",
                                                            }}
                                                          />
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <p>
                                                          {formState[
                                                            question.id
                                                          ]
                                                            .split("/")
                                                            .pop()}
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </p> // Display file name for non-images
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* CAPTCHA Section for single-step/ungrouped forms */}
                            {shouldShowCaptcha && (
                              <div
                                className="captcha-section"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "10px",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <ReCAPTCHA
                                  ref={captchaRef}
                                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                  onChange={handleCaptchaChange}
                                  onExpired={handleCaptchaExpired}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                              }}
                            >
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )))}
          </>
        ) : viewFrom == "client-not-logged-in" ? (
          <>
            {currentGroup ? (
              <>
                <div className="nk-block nk-block-lg">
                  <div className="card">
                    <form
                      autoComplete="off"
                      className="nk-stepper stepper-init is-alter nk-stepper-s1"
                      action="#"
                      id="stepper-create-project"
                      data-step-current="2"
                      noValidate
                      style={{ display: "block" }}
                    >
                      <div className="row g-0 col-sep col-sep-md col-sep-xl">
                        <div className="col-md-3 col-xl-3">
                          <div className="card-inner">
                            <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                              {groups.map((group, index) => (
                                <li
                                  key={group.id}
                                  className={
                                    currentStep === index
                                      ? "current"
                                      : currentStep > index
                                        ? "done"
                                        : ""
                                  }
                                  style={{ marginBottom: "0.725rem" }}
                                >
                                  <div
                                    className="step-item"
                                    data-group-number={index + 1}
                                  >
                                    <div className="step-text">
                                      <div className="lead-text">
                                        {group.group_title}
                                        {group.group_instructions &&
                                        group.group_instructions !== "" ? (
                                          <div className="custom-tooltip-wrapper">
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                              }}
                                            ></em>

                                            <div className="custom-tooltip-box">
                                              {group.group_instructions
                                                .split("\n")
                                                .filter(
                                                  (line) => line.trim() !== "",
                                                )
                                                .map((line, index) => (
                                                  <p>{line}</p>
                                                ))}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>

                        <div
                          className="col-md-9 col-xl-9 p-0"
                          style={{ borderLeft: "1px solid #e5e9f2" }}
                        >
                          <div className="card-inner p-0">
                            <div className="nk-stepper-content">
                              <div className="nk-stepper-steps stepper-steps">
                                <div className="nk-kycfm">
                                  <div
                                    className="nk-kycfm-head"
                                    style={{ background: "#fff" }}
                                  >
                                    <div className="nk-kycfm-title">
                                      <h5 className="title">
                                        {formTitle || "Untitled Form"}
                                      </h5>
                                      {currentStep === 0 && (
                                        <p className="sub-title">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: formDescription,
                                            }}
                                          />
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  {service_data && service_data.length ? (
                                    <div className="card card-bordered">
                                      <div className="card-inner">
                                        <div className="sp-plan-head">
                                          <h4 className="title">Form Services</h4>
                                        </div>
                                        <p>
                                          This form is linked to the following
                                          services. Submitting it will also
                                          generate an order for the selected
                                          products listed below. If you do not
                                          wish to create an order or remove any
                                          product from the order, please uncheck
                                          the services.
                                        </p>
                                        <ul className="nk-kycfm-control-list g-3">
                                          {service_data?.map(([id, name]) => (
                                            <li
                                              className="nk-kycfm-control-item"
                                              key={`ser-${id}`}
                                            >
                                              <input
                                                id={`service-${id}`}
                                                checked={selectedServices.includes(
                                                  id,
                                                )}
                                                onChange={() =>
                                                  handleCheckboxChangeNew(id)
                                                }
                                                className="nk-kycfm-control"
                                                type="checkbox"
                                                name={name}
                                                data-title={name}
                                                value="Yes"
                                              />
                                              <label
                                                className="nk-kycfm-label"
                                                htmlFor={`service-${id}`}
                                              >
                                                <span className="nk-kycfm-label-icon">
                                                  <div className="label-icon">
                                                    <em
                                                      className="icon ni ni-card-view fs26px"
                                                      style={{
                                                        marginRight: "15px",
                                                      }}
                                                    ></em>
                                                  </div>
                                                </span>
                                                <span className="nk-kycfm-label-text">
                                                  {name}
                                                </span>
                                              </label>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="nk-kycfm-content">
                                    {responseMessage && (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: responseMessage,
                                        }}
                                      ></div>
                                    )}
                                    {errorMessage && (
                                      <div className="alert alert-danger alert-icon mb-3">
                                        <em className="icon ni ni-cross-circle"></em>{" "}
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: errorMessage,
                                          }}
                                        ></div>
                                      </div>
                                    )}
                                    <div className="mb-3">
                                      <h5 className="title">
                                        {currentGroup.group_title}
                                      </h5>
                                      <p
                                        className="sub-title"
                                        dangerouslySetInnerHTML={{
                                          __html: currentGroup.group_desc
                                            ? currentGroup.group_desc.replace(
                                                /\n/g,
                                                "<br />",
                                              )
                                            : "",
                                        }}
                                      ></p>
                                    </div>
                                    <div className="row g-gs">
                                      {/*currentGroup.questions.map((questionId) => {
                          const question = formData[0].questions.find(
                            (q) => q.id === questionId
                          );
                          if (!question) {
                            return null;
                          }*/}

                                      {currentGroup.questions
                                        .map((questionId) => {
                                          // Find the corresponding question from formData
                                          const question =
                                            formData[0].questions.find(
                                              (q) => q.id === questionId,
                                            );
                                          return question;
                                        })
                                        .filter(Boolean) // Remove any undefined values if a question is not found
                                        .sort(
                                          (a, b) =>
                                            a.sequenceNumber - b.sequenceNumber,
                                        ) // Sort by sequence number
                                        .map((question) => {
                                          const value =
                                            formState[question.id] ||
                                            question.defaultValue ||
                                            "";

                                          return (
                                            <div
                                              key={question.id}
                                              className={
                                                question.answerType ===
                                                  "label" ||
                                                question.answerType ===
                                                  "text_only"
                                                  ? "question-container col-sm-12"
                                                  : "question-container col-sm-6"
                                              }
                                            >
                                              <div className="form-group question-text mb-0">
                                                {question.answerType ===
                                                "label" ? (
                                                  <label
                                                    className="form-label"
                                                    style={{
                                                      fontSize: "1.275rem",
                                                    }}
                                                  >
                                                    {question.questionText}{" "}
                                                    {question.required && (
                                                      <sup className="text-danger">
                                                        *
                                                      </sup>
                                                    )}
                                                    {question.tooltip &&
                                                    question.tooltip.trim() !==
                                                      "" ? (
                                                      <div className="custom-tooltip-wrapper">
                                                        <em
                                                          className="icon ni ni-info"
                                                          style={{
                                                            color: "#6576ff",
                                                            marginLeft: "5px",
                                                            cursor: "pointer",
                                                            fontSize: "16px",
                                                          }}
                                                        ></em>
                                                        <div className="custom-tooltip-box">
                                                          <p>
                                                            {question.tooltip}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </label>
                                                ) : (
                                                  <>
                                                    {question.answerType !==
                                                    "text_only" ? (
                                                      <label className="form-label">
                                                        {question.questionText}{" "}
                                                        {question.required && (
                                                          <sup className="text-danger">
                                                            *
                                                          </sup>
                                                        )}
                                                        {question.tooltip &&
                                                        question.tooltip.trim() !==
                                                          "" ? (
                                                          <div className="custom-tooltip-wrapper">
                                                            <em
                                                              className="icon ni ni-info"
                                                              style={{
                                                                color:
                                                                  "#6576ff",
                                                                marginLeft:
                                                                  "5px",
                                                                cursor:
                                                                  "pointer",
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            ></em>
                                                            <div className="custom-tooltip-box">
                                                              <p>
                                                                {
                                                                  question.tooltip
                                                                }
                                                              </p>
                                                            </div>
                                                          </div>
                                                        ) : null}
                                                      </label>
                                                    ) : null}
                                                  </>
                                                )}
                                                {question.answerType ===
                                                "text_only" ? (
                                                  <>
                                                    {question.textType ===
                                                    "p" ? (
                                                      <p>
                                                        {question.textOnly}{" "}
                                                      </p>
                                                    ) : question.textType ===
                                                      "oli" ? (
                                                      <ol
                                                        style={{
                                                          paddingLeft: "20px",
                                                          marginLeft: "20px",
                                                        }}
                                                      >
                                                        {question.textOnly
                                                          .split("\n")
                                                          .filter(
                                                            (line) =>
                                                              line.trim() !==
                                                              "",
                                                          )
                                                          .map(
                                                            (line, index) => (
                                                              <li
                                                                key={index}
                                                                style={{
                                                                  listStyleType:
                                                                    "decimal",
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                {line}
                                                              </li>
                                                            ),
                                                          )}
                                                      </ol>
                                                    ) : question.textType ===
                                                      "sli" ? (
                                                      <ul
                                                        style={{
                                                          paddingLeft: "20px",
                                                          marginLeft: "20px",
                                                        }}
                                                      >
                                                        {question.textOnly
                                                          .split("\n")
                                                          .filter(
                                                            (line) =>
                                                              line.trim() !==
                                                              "",
                                                          )
                                                          .map(
                                                            (line, index) => (
                                                              <li
                                                                key={index}
                                                                style={{
                                                                  listStyleType:
                                                                    "disc",
                                                                  paddingLeft:
                                                                    "10px",
                                                                }}
                                                              >
                                                                {line}
                                                              </li>
                                                            ),
                                                          )}
                                                      </ul>
                                                    ) : (
                                                      <p>
                                                        {question.textOnly}{" "}
                                                      </p>
                                                    )}
                                                  </>
                                                ) : null}
                                                {question.imageUrl && (
                                                  <>
                                                    <a
                                                      onClick={() =>
                                                        downloadPdf(
                                                          question.imageUrl,
                                                        )
                                                      }
                                                      style={{
                                                        float: "right",
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <span className="badge badge-outline-primary">
                                                        <em className="icon ni ni-download"></em>{" "}
                                                        Download File
                                                      </span>
                                                    </a>
                                                  </>
                                                )}
                                              </div>

                                              {question.answerType ===
                                                "input" && (
                                                <div className="form-group mb-0">
                                                  <div className="form-control-wrap address_cont">
                                                    {/* Phone validation */}
                                                    {question.validationValue ===
                                                    "validation_phone" ? (
                                                      <ReactPhoneInput
                                                        country="us"
                                                        specialLabel=""
                                                        value={formState[question.id] || ""}
                                                        onChange={(v) => handleChangePhone(question.id, v)}
                                                        inputStyle={{
                                                          width: "100%",
                                                          height: "42px",
                                                          ...(formErrors[question.id] ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" } : {}),
                                                        }}
                                                        buttonStyle={formErrors[question.id] ? { borderColor: "#e85347" } : undefined}
                                                      />
                                                    ) : question.validationValue ===
                                                      "validation_fulladdress" ? (
                                                      <GooglePlacesAutocomplete
                                                        apiKey={
                                                          process.env
                                                            .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                        }
                                                        selectProps={{
                                                          value: formState[
                                                            question.id
                                                          ]
                                                            ? {
                                                                label:
                                                                  formState[
                                                                    question.id
                                                                  ],
                                                                value:
                                                                  formState[
                                                                    question.id
                                                                  ],
                                                              }
                                                            : null,
                                                          onChange: (address) =>
                                                            handleAddressSelect(
                                                              question.id,
                                                              address,
                                                            ),
                                                          placeholder: Address
                                                            ? null
                                                            : "Enter your address...",
                                                          styles: {
                                                            input: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                              minHeigh: "40px",
                                                            }),
                                                            option: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            singleValue: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              color: "black",
                                                            }),
                                                            menu: (
                                                              provided,
                                                            ) => ({
                                                              ...provided,
                                                              zIndex: 9,
                                                            }),
                                                          },
                                                        }}
                                                      />
                                                    ) : question.validationValue ===
                                                      "validation_country" ? (
                                                      <Select
                                                        id="_country"
                                                        className="customCountrySelect-addClient"
                                                        name="_country"
                                                        label="Country"
                                                        options={countryOptions}
                                                        value={country}
                                                        onChange={(
                                                          selectedOption,
                                                        ) =>
                                                          handleChangeCountry(
                                                            question.id,
                                                            selectedOption,
                                                          )
                                                        }
                                                        styles={{
                                                          control: (
                                                            provided,
                                                          ) => ({
                                                            ...provided,
                                                            minHeight: "45px",
                                                          }),
                                                          menu: (
                                                            provided,
                                                            state,
                                                          ) => ({
                                                            ...provided,
                                                            zIndex: 9,
                                                          }),
                                                        }}
                                                        placeholder="Select Country"
                                                      />
                                                    ) : (
                                                      <input
                                                        className="form-control form-control-lg"
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        value={value}
                                                        type="text"
                                                        maxLength={
                                                          question.maxLength ||
                                                          100
                                                        }
                                                      />
                                                    )}
                                                  </div>
                                                  <div
                                                    className="helper-text"
                                                    style={{ marginTop: "6px" }}
                                                  >
                                                    {question.maxLength && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Maximum length is{" "}
                                                        {question.maxLength}{" "}
                                                        characters.
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "number_only" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only numbers are allowed
                                                        (e.g. 123456).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "alphabet_only" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only alphabets are
                                                        allowed (e.g. JohnDoe).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "alphanumeric" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        Only alphanumeric
                                                        characters are allowed
                                                        (e.g. John123).
                                                        <br />
                                                      </small>
                                                    )}
                                                    {question.inputFormat ===
                                                      "open" && (
                                                      <small
                                                        className="text-muted"
                                                        style={{
                                                          display: "block",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                        >
                                                          •
                                                        </span>{" "}
                                                        You can enter any
                                                        characters.
                                                        <br />
                                                      </small>
                                                    )}
                                                  </div>

                                                  {/* Display form errors if present */}
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "signature" && (
                                                <>
                                                  <ul className="nav nav-tabs">
                                                    <li className="nav-item">
                                                      <a
                                                        className={
                                                          signatureType ===
                                                            "draw" ||
                                                          signatureType === ""
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                        }
                                                        data-toggle="tab"
                                                        onClick={() =>
                                                          setSignatureType(
                                                            "draw",
                                                          )
                                                        }
                                                        href="#tabItem6"
                                                      >
                                                        <em className="icon ni ni-edit-alt"></em>
                                                        <span>Draw</span>
                                                      </a>
                                                    </li>
                                                    <li className="nav-item">
                                                      <a
                                                        className={
                                                          signatureType ===
                                                          "choose"
                                                            ? "nav-link active"
                                                            : "nav-link"
                                                        }
                                                        data-toggle="tab"
                                                        onClick={() =>
                                                          setSignatureType(
                                                            "choose",
                                                          )
                                                        }
                                                        href="#tabItem5"
                                                      >
                                                        <em className="icon ni ni-list-check"></em>
                                                        <span>Choose</span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                  <div className="tab-content">
                                                    <div
                                                      className={
                                                        signatureType ===
                                                        "choose"
                                                          ? "tab-pane active"
                                                          : "tab-pane"
                                                      }
                                                      id="tabItem5"
                                                    >
                                                      <div className="example-alert mb-4">
                                                        <div className="alert alert-light">
                                                          Pick a style for your
                                                          signature (Authorized
                                                          Person Name).
                                                        </div>
                                                      </div>
                                                      <div className="form-group mb-4">
                                                        <div className="form-control-wrap">
                                                          <input
                                                            className={`form-control form-control-lg`}
                                                            onChange={(e) =>
                                                              handleChangeSignature(
                                                                question.id,
                                                                e.target.value,
                                                              )
                                                            }
                                                            onInput={(e) => {
                                                              e.target.value =
                                                                e.target.value.replace(
                                                                  /[^a-zA-Z0-9 ]/gi,
                                                                  "",
                                                                );
                                                            }}
                                                            value={
                                                              signatureText
                                                            }
                                                            type="text"
                                                            maxLength={100}
                                                            placeholder="Authorized Person Name"
                                                          />
                                                        </div>
                                                        {formErrors[
                                                          question.id
                                                        ] && (
                                                          <FormHelperText error>
                                                            {
                                                              formErrors[
                                                                question.id
                                                              ]
                                                            }
                                                          </FormHelperText>
                                                        )}
                                                      </div>

                                                      <h6 className="title">
                                                        Choose Style
                                                      </h6>

                                                      <ul className="cc-pay-method">
                                                        <li className="cc-pay-dd dropdown">
                                                          <a
                                                            href="#"
                                                            className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                                            data-toggle="dropdown"
                                                          >
                                                            <span
                                                              style={{
                                                                fontFamily:
                                                                  signatureClass,
                                                              }}
                                                            >
                                                              {signatureText ||
                                                                "Your Signature"}
                                                            </span>
                                                          </a>
                                                          <div className="dropdown-menu dropdown-menu-auto">
                                                            <ul className="link-list-plain">
                                                              {cursiveFonts.map(
                                                                (
                                                                  font,
                                                                  index,
                                                                ) => (
                                                                  <li
                                                                    key={
                                                                      index
                                                                    }
                                                                  >
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        setSignatureClass(
                                                                          font.value,
                                                                        )
                                                                      }
                                                                      className="cc-pay-item"
                                                                    >
                                                                      <span className="cc-pay-item-name">
                                                                        <span
                                                                          className="cc-pay-item-method"
                                                                          style={{
                                                                            fontFamily:
                                                                              font.value,
                                                                          }}
                                                                        >
                                                                          {signatureText !==
                                                                          ""
                                                                            ? signatureText
                                                                            : font.name}
                                                                        </span>
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ),
                                                              )}
                                                            </ul>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                      <div
                                                        className="signature-preview mt-3"
                                                        id={`styled-text-container${question.id}`}
                                                        style={{
                                                          fontFamily:
                                                            signatureClass,
                                                          fontSize: "40px",
                                                          width: "480px",
                                                          height: "80px",
                                                          background:
                                                            "trasnparent",
                                                          backgroundColor:
                                                            "transparent",
                                                          border: "none",
                                                          lineHeight:
                                                            "80px",
                                                          color: "#000",
                                                        }}
                                                      >
                                                        {signatureText ||
                                                          "Your Signature"}
                                                      </div>

                                                      <div
                                                        className="col-sm-12 mt-4 pl-0"
                                                        style={{
                                                          clear: "both",
                                                        }}
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-primary"
                                                          style={{
                                                            margin:
                                                              "13px 0px 12px 0px",
                                                          }}
                                                          onClick={() =>
                                                            saveChooseImage(
                                                              question.id,
                                                            )
                                                          }
                                                        >
                                                          <em className="icon ni ni-folder-check"></em>{" "}
                                                          <span>
                                                            Save Signature
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </div>
                                                    <div
                                                      className={
                                                        signatureType ===
                                                          "draw" ||
                                                        signatureType === ""
                                                          ? "tab-pane active"
                                                          : "tab-pane"
                                                      }
                                                      id="tabItem6"
                                                    >
                                                      <div className="row">
                                                        <div className="col-sm-12">
                                                          <div className="example-alert mb-4">
                                                            <div className="alert alert-light">
                                                              Please Save the
                                                              signature to
                                                              proceed.
                                                            </div>
                                                          </div>
                                                          {formState[
                                                            question.id
                                                          ] && (
                                                            <div className="uploaded-file-preview">
                                                              <img
                                                                src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                                  formState[
                                                                    question.id
                                                                  ]
                                                                }`}
                                                                alt="Uploaded Signature"
                                                                style={{
                                                                  maxWidth:
                                                                    "200px",
                                                                }}
                                                              />
                                                            </div>
                                                          )}
                                                          <div
                                                            id={`divSig${question.id}`}
                                                            style={{
                                                              display: "none",
                                                            }}
                                                          >
                                                            <div className="mb-4">
                                                              <img
                                                                src=""
                                                                className="clsimgSig"
                                                                height="100"
                                                                width="200"
                                                                onerror="this.style.display='none'"
                                                              />
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <strong>
                                                              Signature
                                                            </strong>
                                                          </div>
                                                        </div>

                                                        <div className="col-sm-12">
                                                          <SignatureCanvas
                                                            clearOnResize={true}
                                                            canvasProps={{
                                                              className:
                                                                styles.sigPad,
                                                            }}
                                                            velocityFilterWeight={
                                                              0.7
                                                            }
                                                            throttle={50}
                                                            ref={(ref) =>
                                                              (sigPadRefs.current[
                                                                question.id
                                                              ] = ref)
                                                            }
                                                          />
                                                        </div>
                                                        <div className="col-sm-12 mt-4">
                                                          <button
                                                            className="btn btn-warning"
                                                            style={{
                                                              margin:
                                                                "13px 0px 12px 0px",
                                                            }}
                                                            onClick={() =>
                                                              clearSignature(
                                                                question.id,
                                                              )
                                                            }
                                                            type="button"
                                                          >
                                                            <em className="icon ni ni-delete"></em>{" "}
                                                            <span>Clear</span>
                                                          </button>
                                                          {/*<button
                                            className="btn btn-success"
                                            style={{
                                              margin: "13px 0px 12px 10px",
                                            }}
                                            type="button"
                                            onClick={() =>
                                              previewSignature(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-eye"></em>{" "}
                                            <span>Preview</span>
                                          </button>*/}
                                                          <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            style={{
                                                              margin:
                                                                "13px 0px 12px 10px",
                                                            }}
                                                            onClick={() =>
                                                              saveSignature(
                                                                question.id,
                                                              )
                                                            }
                                                          >
                                                            <em className="icon ni ni-folder-check"></em>{" "}
                                                            <span>
                                                              Save Signature
                                                            </span>
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                                )}
                                              {question.answerType ===
                                                "fixed" && (
                                                <>
                                                  <div className="form-group mb-0">
                                                    <div className="form-control-wrap">
                                                      <input
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChangeFixed(
                                                            question.id,
                                                            question.answer,
                                                          )
                                                        }
                                                        value={question.answer}
                                                        type="text"
                                                        maxLength={255}
                                                      />
                                                    </div>
                                                    {formErrors[question.id] && (
                                                      <FormHelperText error>
                                                        {
                                                          formErrors[
                                                            question.id
                                                          ]
                                                        }
                                                      </FormHelperText>
                                                    )}
                                                  </div>
                                                  <CopyToClipboard
                                                    text={question.answer}
                                                    onCopy={() =>
                                                      setCopied(true)
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <div className="form-note text-primary">
                                                      <strong>
                                                        Copy to Clipboard{" "}
                                                        {copied ? (
                                                          <span>
                                                            <em className="icon ni ni-done"></em>
                                                          </span>
                                                        ) : null}
                                                      </strong>
                                                    </div>
                                                  </CopyToClipboard>
                                                </>
                                              )}
                                              {question.answerType ===
                                                "label" && (
                                                <div className="form-group mb-0">
                                                  <h6></h6>
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "textarea" && (
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <textarea
                                                      className={`form-control form-control-lg`}
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      placeholder=""
                                                      value={value}
                                                      maxLength={
                                                        question.maxLength ||
                                                        500
                                                      }
                                                    ></textarea>
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "datetime" && (
                                                <div className="form-group">
                                                  <DateTimePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    format="MM-dd-yyyy hh:mm a"
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(date) =>
                                                      handleChange(
                                                        question.id,
                                                        date,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "date" && (
                                                <div className="form-group">
                                                  <DatePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    format="MM-dd-yyyy"
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(date) =>
                                                      handleChange(
                                                        question.id,
                                                        date,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "time" && (
                                                <div className="form-group">
                                                  <TimePicker
                                                    variant="inline"
                                                    inputVariant="outlined"
                                                    fullWidth
                                                    value={
                                                      formState[question.id] ||
                                                      null
                                                    }
                                                    onChange={(time) =>
                                                      handleChange(
                                                        question.id,
                                                        time,
                                                      )
                                                    }
                                                  />
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "dropdown" && (
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-control-select">
                                                      <select
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        value={value}
                                                      >
                                                        <option value="">
                                                          Select an option
                                                        </option>
                                                        {question.options.map(
                                                          (option, index) => (
                                                            <option
                                                              key={index}
                                                              value={option}
                                                            >
                                                              {option}
                                                            </option>
                                                          ),
                                                        )}
                                                      </select>
                                                    </div>
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "checkbox" && (
                                                <>
                                                  <div className="mt-2 prettyprint ">
                                                    <div className="row">
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <div
                                                            className="col-md-6 mb-1"
                                                            key={`options_${index}`}
                                                          >
                                                            <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                              <input
                                                                type="checkbox"
                                                                className="custom-control-input vdrSelected"
                                                                id={`question_checkbox_${question.id}_${index}`}
                                                                checked={
                                                                  (Array.isArray(formState[question.id])
                                                                    ? formState[question.id].some((v) => v.toLowerCase() === option.toLowerCase())
                                                                    : formState[question.id]?.includes(option)) || false
                                                                }
                                                                onChange={(e) =>
                                                                  handleCheckboxChange(
                                                                    question.id,
                                                                    option,
                                                                    e.target
                                                                      .checked,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                className="custom-control-label"
                                                                htmlFor={`question_checkbox_${question.id}_${index}`}
                                                              >
                                                                {option}
                                                              </label>
                                                            </div>
                                                            {formErrors[
                                                              question.id
                                                            ] && (
                                                              <FormHelperText
                                                                error
                                                              >
                                                                {
                                                                  formErrors[
                                                                    question.id
                                                                  ]
                                                                }
                                                              </FormHelperText>
                                                            )}
                                                          </div>
                                                        ),
                                                      )}
                                                    </div>
                                                  </div>
                                                </>
                                              )}

                                              {question.answerType ===
                                                "radio" && (
                                                <div style={{ marginTop: "8px" }}>
                                                  {question.options.map(
                                                    (option, index) => {
                                                      const isSelected = formState[question.id] === option;
                                                      const hKey = `radio_${question.id}_${index}`;
                                                      const isHovered = hoveredId === hKey;
                                                      const showTeal = isSelected || isHovered;
                                                      return (
                                                        <label
                                                          key={index}
                                                          htmlFor={hKey}
                                                          onMouseEnter={() => setHoveredId(hKey)}
                                                          onMouseLeave={() => setHoveredId(null)}
                                                          style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "14px",
                                                            padding: "14px 16px",
                                                            borderRadius: "8px",
                                                            border: showTeal ? "1.5px solid #1ee0ac" : "1.5px solid #e5e9f2",
                                                            background: showTeal ? "#edfaf6" : "#ffffff",
                                                            cursor: "pointer",
                                                            transition: "all 0.15s ease",
                                                            marginBottom: "10px",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={hKey}
                                                            name={`radio_${question.id}`}
                                                            checked={isSelected}
                                                            onChange={() => handleChange(question.id, option)}
                                                            value={option}
                                                            style={{ display: "none" }}
                                                          />
                                                          <span
                                                            style={{
                                                              fontSize: "13.5px",
                                                              color: showTeal ? "#1c2b46" : "#526484",
                                                              fontWeight: showTeal ? 600 : 400,
                                                              lineHeight: 1.55,
                                                              flex: 1,
                                                            }}
                                                          >
                                                            {option}
                                                          </span>
                                                          <span style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            borderRadius: "50%",
                                                            background: isSelected ? "#1ee0ac" : "transparent",
                                                            border: isSelected ? "none" : "2px solid #d0d5dd",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            flexShrink: 0,
                                                            transition: "all 0.15s ease",
                                                          }}>
                                                            {isSelected && (
                                                              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                                <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                              </svg>
                                                            )}
                                                          </span>
                                                        </label>
                                                      );
                                                    },
                                                  )}
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                              {question.answerType ===
                                                "image_input" && (
                                                <div className="form-group">
                                                  <div
                                                    className="form-control-group"
                                                    id="fileContainer"
                                                  >
                                                    <input
                                                      type="file"
                                                      id={`add_picture_${question.id}`}
                                                      className="file-block"
                                                      name="add_picture"
                                                      accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                      onChange={(e) =>
                                                        handleFileChange(
                                                          question.id,
                                                          e,
                                                        )
                                                      }
                                                    />
                                                    {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                    {formState[question.id] && (
                                                      <div className="uploaded-file-preview">
                                                        {formState[
                                                          question.id
                                                        ].match(
                                                          /\.(jpeg|jpg|png)$/i,
                                                        ) ? (
                                                          <>
                                                            <img
                                                              src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                                formState[
                                                                  question.id
                                                                ]
                                                              }`}
                                                              alt="Uploaded preview"
                                                              style={{
                                                                maxWidth:
                                                                  "100px",
                                                              }}
                                                            />
                                                            <a
                                                              onClick={() =>
                                                                removeUploadedFile(
                                                                  question.id,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color: "red",
                                                                fontSize:
                                                                  "20px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                              className="fs-20"
                                                              title="Delete"
                                                            >
                                                              <em className="icon ni ni-trash-fill"></em>
                                                            </a>
                                                          </>
                                                        ) : (
                                                          <p>
                                                            {formState[
                                                              question.id
                                                            ]
                                                              .split("/")
                                                              .pop()}
                                                            <a
                                                              onClick={() =>
                                                                removeUploadedFile(
                                                                  question.id,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color: "red",
                                                                fontSize:
                                                                  "20px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                              className="fs-20"
                                                              title="Delete"
                                                            >
                                                              <em className="icon ni ni-trash-fill"></em>
                                                            </a>
                                                          </p> // Display file name for non-images
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                  {formErrors[question.id] && (
                                                    <FormHelperText error>
                                                      {formErrors[question.id]}
                                                    </FormHelperText>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* CAPTCHA Section - Show on last step for multi-step forms or on single-step forms */}
                          {shouldShowCaptcha && (
                            <div
                              className="captcha-section"
                              style={{
                                marginTop: "20px",
                                marginBottom: "10px",
                              }}
                            >
                              <ReCAPTCHA
                                ref={captchaRef}
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onChange={handleCaptchaChange}
                                onExpired={handleCaptchaExpired}
                              />
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "20px",
                            }}
                            className="border-top"
                          >
                            <ul
                              role="menu"
                              aria-label="Pagination"
                              className="mt-4"
                            >
                              {currentStep > 0 && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    setCurrentStep(currentStep - 1)
                                  }
                                  style={{
                                    marginBottom: "10px",
                                    marginTop: "10px",
                                  }}
                                  className="back-button-mobile"
                                >
                                  Back
                                </Button>
                              )}
                              {allowSkip === 1 &&
                                isOnboarding &&
                                isFilled !== 1 &&
                                isSkipped !== 1 && (
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={onSkipStep}
                                    style={{
                                      marginLeft: "10px",
                                      marginBottom: "10px",
                                    }}
                                    className="skip-button-mobile"
                                  >
                                    <em className="icon ni ni-forward"></em>{" "}
                                    Skip This Step
                                  </Button>
                                )}
                              {(isFilled === 1 || isSkipped === 1) && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={onNextStep}
                                  style={{
                                    marginLeft: "10px",
                                    marginBottom: "10px",
                                  }}
                                  className="next-button-mobile"
                                >
                                  <em className="icon ni ni-forward"></em> Next
                                  Step
                                </Button>
                              )}
                              {currentStep < groups.length - 1 ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleNextStep}
                                  style={{
                                    marginLeft: "10px",
                                    marginBottom: "10px",
                                  }}
                                  disabled={isFormInReviewMode}
                                >
                                  Save & Continue
                                </Button>
                              ) : (
                                <>
                                  {allow_submit === 1 && (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={handleSubmit}
                                      style={{
                                        marginLeft: "10px",
                                        marginBottom: "10px",
                                        marginTop: "10px",
                                      }}
                                      disabled={loading}
                                    >
                                      {loading ? "Loading..." : "Save & Finish"}
                                    </Button>
                                  )}
                                  {allow_submit === 0 && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-warning"
                                      style={{
                                        marginLeft: "10px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      Submission is disabled for this form.
                                    </button>
                                  )}
                                </>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            ) : (
              hasUngroupedQuestions && (
                <>
                  <div className="nk-block nk-block-lg">
                    <div className="card">
                      <form
                        autoComplete="off"
                        className="nk-stepper stepper-init is-alter nk-stepper-s1"
                        action="#"
                        id="stepper-create-project"
                        data-step-current="2"
                        noValidate
                        style={{ display: "block" }}
                      >
                        <div className="row g-0 col-sep col-sep-md col-sep-xl">
                          <div className="col-md-3 col-xl-3">
                            <div className="card-inner">
                              <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                                {groups.map((group, index) => (
                                  <li
                                    key={group.id}
                                    className={
                                      currentStep === index
                                        ? "current"
                                        : currentStep > index
                                          ? "done"
                                          : ""
                                    }
                                  >
                                    <div className="step-item">
                                      <div className="step-text">
                                        <div className="lead-text">
                                          {group.group_title}
                                        </div>
                                        <div
                                          className="sub-text"
                                          dangerouslySetInnerHTML={{
                                            __html: group.group_desc,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>

                          <div className="col-md-9 col-xl-9">
                            <div className="card-inner">
                              <div className="nk-stepper-content">
                                <div className="nk-stepper-steps stepper-steps">
                                  <div className="nk-kycfm">
                                    <div
                                      className="nk-kycfm-head"
                                      style={{ background: "#f5f6fa" }}
                                    >
                                      <div className="nk-kycfm-title">
                                        <h5 className="title">
                                          {formTitle || "Untitled Form"}
                                        </h5>
                                        <p className="sub-title">
                                          {formDescription || "Untitled Form"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="nk-kycfm-content">
                                      {responseMessage && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: responseMessage,
                                          }}
                                        ></div>
                                      )}
                                      {errorMessage && (
                                        <div className="alert alert-danger alert-icon mb-3">
                                          <em className="icon ni ni-cross-circle"></em>{" "}
                                          Please fill out all the required
                                          questions!
                                        </div>
                                      )}
                                      <div className="row g-gs">
                                        {ungroupedQuestions.map((question) => (
                                          <div
                                            key={question.id}
                                            className="question-container col-sm-6"
                                          >
                                            <div className="form-group question-text mb-0">
                                              <label className="form-label">
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                                {question.tooltip &&
                                                question.tooltip.trim() !==
                                                  "" ? (
                                                  <div className="custom-tooltip-wrapper">
                                                    <em
                                                      className="icon ni ni-info"
                                                      style={{
                                                        color: "#6576ff",
                                                        marginLeft: "5px",
                                                        cursor: "pointer",
                                                        fontSize: "16px",
                                                      }}
                                                    ></em>
                                                    <div className="custom-tooltip-box">
                                                      <p>{question.tooltip}</p>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </label>
                                            </div>
                                            {question.imageUrl && (
                                              <img
                                                src={question.imageUrl}
                                                alt="Admin Uploaded"
                                                className="question-image"
                                              />
                                            )}
                                            {question.answerType ===
                                              "input" && (
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    type="text"
                                                    maxLength={
                                                      question.maxLength || 100
                                                    }
                                                    value={
                                                      formState[question.id] ||
                                                      question.defaultValue ||
                                                      ""
                                                    }
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "textarea" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <textarea
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    placeholder=""
                                                    maxLength={
                                                      question.maxLength || 500
                                                    }
                                                    value={
                                                      formState[question.id] ||
                                                      question.defaultValue ||
                                                      ""
                                                    }
                                                  ></textarea>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "datetime" && (
                                              <div className="form-group">
                                                <DateTimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy hh:mm a"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "date" && (
                                              <div className="form-group">
                                                <DatePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  format="MM-dd-yyyy"
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(date) =>
                                                    handleChange(
                                                      question.id,
                                                      date,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType === "time" && (
                                              <div className="form-group">
                                                <TimePicker
                                                  variant="inline"
                                                  inputVariant="outlined"
                                                  fullWidth
                                                  value={
                                                    formState[question.id] ||
                                                    null
                                                  }
                                                  onChange={(time) =>
                                                    handleChange(
                                                      question.id,
                                                      time,
                                                    )
                                                  }
                                                />
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "dropdown" && (
                                              <div className="form-group">
                                                <div className="form-control-wrap">
                                                  <div className="form-control-select">
                                                    <select
                                                      className={`form-control form-control-lg`}
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      value={
                                                        formState[
                                                          question.id
                                                        ] ||
                                                        question.defaultValue ||
                                                        ""
                                                      }
                                                    >
                                                      <option value="">
                                                        Select an option
                                                      </option>
                                                      {question.options.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option}
                                                          >
                                                            {option}
                                                          </option>
                                                        ),
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "checkbox" && (
                                              <>
                                                <div className="mt-2 prettyprint ">
                                                  <div className="row">
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <div
                                                          className="col-md-6 mb-1"
                                                          key={`options_${index}`}
                                                        >
                                                          <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                            <input
                                                              type="checkbox"
                                                              className="custom-control-input vdrSelected"
                                                              id={`question_checkbox_${question.id}_${index}`}
                                                              checked={
                                                                (Array.isArray(formState[question.id])
                                                                  ? formState[question.id].some((v) => v.toLowerCase() === option.toLowerCase())
                                                                  : formState[question.id]?.includes(option)) || false
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxChange(
                                                                  question.id,
                                                                  option,
                                                                  e.target
                                                                    .checked,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              className="custom-control-label"
                                                              htmlFor={`question_checkbox_${question.id}_${index}`}
                                                            >
                                                              {option}
                                                            </label>
                                                          </div>
                                                          {formErrors[
                                                            question.id
                                                          ] && (
                                                            <FormHelperText
                                                              error
                                                            >
                                                              {
                                                                formErrors[
                                                                  question.id
                                                                ]
                                                              }
                                                            </FormHelperText>
                                                          )}
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              </>
                                            )}

                                            {question.answerType ===
                                              "radio" && (
                                              <div style={{ marginTop: "8px" }}>
                                                {question.options.map(
                                                  (option, index) => {
                                                    const isSelected = formState[question.id] === option;
                                                    const hKey = `radio_${question.id}_${index}`;
                                                    const isHovered = hoveredId === hKey;
                                                    const showTeal = isSelected || isHovered;
                                                    return (
                                                      <label
                                                        key={index}
                                                        htmlFor={hKey}
                                                        onMouseEnter={() => setHoveredId(hKey)}
                                                        onMouseLeave={() => setHoveredId(null)}
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "14px",
                                                          padding: "14px 16px",
                                                          borderRadius: "8px",
                                                          border: showTeal ? "1.5px solid #1ee0ac" : "1.5px solid #e5e9f2",
                                                          background: showTeal ? "#edfaf6" : "#ffffff",
                                                          cursor: "pointer",
                                                          transition: "all 0.15s ease",
                                                          marginBottom: "10px",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={hKey}
                                                          name={`radio_${question.id}`}
                                                          checked={isSelected}
                                                          onChange={() => handleChange(question.id, option)}
                                                          value={option}
                                                          style={{ display: "none" }}
                                                        />
                                                        <span
                                                          style={{
                                                            fontSize: "13.5px",
                                                            color: showTeal ? "#1c2b46" : "#526484",
                                                            fontWeight: showTeal ? 600 : 400,
                                                            lineHeight: 1.55,
                                                            flex: 1,
                                                          }}
                                                        >
                                                          {option}
                                                        </span>
                                                        <span style={{
                                                          width: "24px",
                                                          height: "24px",
                                                          borderRadius: "50%",
                                                          background: isSelected ? "#1ee0ac" : "transparent",
                                                          border: isSelected ? "none" : "2px solid #d0d5dd",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent: "center",
                                                          flexShrink: 0,
                                                          transition: "all 0.15s ease",
                                                        }}>
                                                          {isSelected && (
                                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                              <path d="M2 6.5L5 9.5L11 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                          )}
                                                        </span>
                                                      </label>
                                                    );
                                                  },
                                                )}
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "image_input" && (
                                              <div className="form-group">
                                                <div
                                                  className="form-control-group"
                                                  id="fileContainer"
                                                >
                                                  <input
                                                    type="file"
                                                    id={`add_picture_${question.id}`}
                                                    className="file-block"
                                                    name="add_picture"
                                                    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                                    onChange={(e) =>
                                                      handleFileChange(
                                                        question.id,
                                                        e,
                                                      )
                                                    }
                                                  />
                                                  {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                  {formState[question.id] && (
                                                    <div className="uploaded-file-preview">
                                                      {formState[
                                                        question.id
                                                      ].match(
                                                        /\.(jpeg|jpg|png)$/i,
                                                      ) ? (
                                                        <>
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_response_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded preview"
                                                            style={{
                                                              maxWidth: "100px",
                                                            }}
                                                          />
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </>
                                                      ) : (
                                                        <p>
                                                          {formState[
                                                            question.id
                                                          ]
                                                            .split("/")
                                                            .pop()}
                                                          <a
                                                            onClick={() =>
                                                              removeUploadedFile(
                                                                question.id,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "red",
                                                              fontSize: "20px",
                                                              marginLeft: "5px",
                                                            }}
                                                            className="fs-20"
                                                            title="Delete"
                                                          >
                                                            <em className="icon ni ni-trash-fill"></em>
                                                          </a>
                                                        </p> // Display file name for non-images
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* CAPTCHA Section for single-step/ungrouped forms */}
                            {shouldShowCaptcha && (
                              <div
                                className="captcha-section"
                                style={{
                                  marginTop: "20px",
                                  marginBottom: "10px",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <ReCAPTCHA
                                  ref={captchaRef}
                                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                  onChange={handleCaptchaChange}
                                  onExpired={handleCaptchaExpired}
                                />
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                              }}
                            >
                              {allow_submit === 1 && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSubmit}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )
            )}
          </>
        ) : null}
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default FormRendererClient;
